<template>
  <div class="rf-config-pacotes">
    <template v-if='status !== ""'>
      <RF-Status :cpntStatus='status' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else>
      <div class="rf-pacotes">
        <template v-if='arrPacotes.length > 0 || arrPacotesSelected.length > 0'>
          <div v-if="cpntClu === null && $store.state.token.clu_mu !== 'a' && cpntIntencao === ''" style="text-align: center; background-color: #d9e700; margin-top: -15px;  margin-bottom: 10px; padding: 5px 5px; border-radius: 6px; border-collapse: collapse; border-style: hidden; box-shadow: 0px 0px 0px 1px #c6c4c4;">
            Solicite ao  Administrador da sua Licença de Uso para testar novos pacotes.
          </div>
          <p v-else-if="cpntClu === null && [ 'pag_setup', 'pag_setup_2', 'pag_setup_intencao' ].indexOf($route.name) === -1 && cpntIntencao === ''">
            <i class="fa fa-angle-double-right" aria-hidden="true"></i>
            Pacotes
          </p>
          <div v-else-if="[ 'pag_setup', 'pag_setup_2', 'pag_setup_intencao' ].indexOf($route.name) === -1 && cpntIntencao === ''" style="text-align: center; background-color: #d9e700; margin-top: -15px;  margin-bottom: 10px; padding: 5px 5px; border-radius: 6px; border-collapse: collapse; border-style: hidden; box-shadow: 0px 0px 0px 1px #c6c4c4;">
            Atenção - É apenas para consulta e simulação dos valores.
            <br/>
            Caso o Cliente deseje adicionar para teste precisa fazer pela Licença de Uso DELE.
            <br/>
          </div>

          <div class="rf-valor-pacote">
            <table>
              <tr >
                <td rowspan="1" class="rf-titulo-pacote">
                  <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                  <template v-if="[ 'pag_setup', 'pag_setup_2', 'pag_setup_intencao' ].indexOf($route.name) === -1 && [ '', null, undefined ].indexOf($store.state.licenca.n_dias_teste) === -1 && Number($store.state.licenca.n_dias_teste) > 0 && [ 'l', 'lv' ].indexOf($store.state.licenca.clu_con) === -1">
                    Disponíveis para teste por {{ $store.state.licenca.n_dias_teste }} dias.
                  </template>
                  <template v-else>
                    Disponíveis
                  </template>
                </td>
                <td rowspan="4">
                  &nbsp;
                </td>
                <td rowspan="1" class="rf-titulo-pacote">
                  <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                  {{ [ 'pag_setup', 'pag_setup_2', 'pag_setup_intencao' ].indexOf($route.name) !== -1 || cpntIntencao !== '' ? 'Selecionados' : ([ 'd', 'dv' ].indexOf(contratoCLU) !== -1 ? 'Testando' : 'Contratados') }}
                </td>
              </tr>
              <tr>
                <td rowspan="3">
                  <ul class="list-group" >
                    <li :class="pac.arrClass" v-for="(pac, index) in arrPacotes" v-if='pac.pac_id !== "1"' :id='"arrPacotes_q_" + index' :data-pac-index='index' :key='index' :data-pac-ref='"arrPacotes"'>
                      <div style="line-height: 33px;">
                        <span v-html='pac.pac_nome'></span>
                        <!-- <RF-Explica v-if="flag === true" :data-time='time'
                          :cpntId='"rf-info-pac" + pac.pac_id' 
                          :cpntTitle='pac.j_pac_desc'
                        ></RF-Explica> -->

                        <RF-Explica v-if="flag === true && [ '', null, undefined ].indexOf(pac.info) === -1 && [ '', null, undefined ].indexOf(pac.info.mensagem) === -1" :data-time='time'
                          :cpntId='"rf-info-pac-" + pac.pac_id + "-info"'
                          
                          :cpntTitle='pac.info.mensagem'
                          :cpntPositionMy='"top left"'
                          :cpntPositionAt='"bottom right"'
                          cpntClasses="rf-qtip qtip-info-pacote"
                        ></RF-Explica>
                      </div>

                      <RF-Button v-if="flag === true && pac.disabled !== null && cpntClu === null" :data-time='time' style="float: right;"
                        :cpntId='"rf-pac-nec-" + pac.pac_id'
                        :cpntStatus='""' 
                        :_cpntIcone='"fa fa-angle-double-right"'
                        :cpntTexto='$store.state.token.dep_plus === true ? "Incluir" : "Quero testar!"'
                        :cpntClass='$store.state.token.dep_plus === true ? [ "btn", "btn-default" ] : [ "btn", "btn-success" ]'
                        :cpntExplica='pac.explica'
                        :cpntDisabled='pac.disabled'
                        @onClickButton='onChangePacote("arrPacotes", index)'
                      ></RF-Button>
                    </li>
                  </ul>
                </td>

                <td rowspan="1" style='height: 30px;'>
                  <ul class="list-group">
                    <li :class="pac.arrClass" v-for="(pac, index) in arrPacotesSelected" v-if='pac.pac_id !== "1"' :id='"arrPacotesSelected_q_" + index' :data-pac-index='index' :key='index' :data-pac-ref='"arrPacotesSelected"'>
                      
                      <!-- ({{ pac.contratado !== 's' && pac.disabled === false }}) -->
                      <!-- ({{ pac.explica === null }}) -->
                      <!-- {{ $store.state.token.usuario !== 'SuporteRF' }} -->
                      <!-- {{ pac.contratado !== 't' }} -->
                      <!-- <template v-if="$store.state.token.dep_plus === false"> -->
                      <RF-Button v-if="flag === true && pac.disabled !== null && cpntClu === null && ($store.state.token.dep_plus === true || [ 'l', 'lv' ].indexOf(contratoCLU) === -1 || $store.state.token.usuario === 'SuporteRF')" :data-time='time'
                        :cpntId='"rf-pac-dep-" + pac.pac_id'
                        :cpntStatus='""' 
                        :_cpntIcone='"fa fa-angle-double-left"'
                        :cpntTexto='"Remover"'
                        :cpntClass='[ "btn", "btn-default" ]'
                        :cpntExplica='pac.explica'
                        :cpntDisabled='pac.disabled'

                        @onClickButton='onChangePacote("arrPacotesSelected", index)'
                      ></RF-Button>
                      <div v-else style="width: 0px;" :style="[ '', null, undefined, '0' ].indexOf(pac.bilhetagem_valor) === -1  && (pac.contratado === 't' || (cpntClu === null && [ 'd', 'dv' ].indexOf(contratoCLU) !== -1)) ? 'height: 55px;' : 'height: 35px;'" class="tamanho-li"></div>

                      <div>
                        <span v-html='pac.pac_nome'></span>
                        <!-- <RF-Explica v-if="flag === true" :data-time='time'
                          :cpntId='"rf-info-pac" + pac.pac_id' 
                          :cpntTitle='pac.j_pac_desc'
                        ></RF-Explica> -->
                        
                        <RF-Explica v-if="flag === true && [ '', null, undefined ].indexOf(pac.info) === -1 && [ '', null, undefined ].indexOf(pac.info.mensagem) === -1" :data-time='time'
                          :cpntId='"rf-info-pac-" + pac.pac_id + "-info"' 
                          
                          :cpntTitle='pac.info.mensagem'
                          :cpntPositionMy='"top right"'
                          :cpntPositionAt='"bottom left"'
                          cpntClasses="rf-qtip qtip-info-pacote"
                        ></RF-Explica>
                      </div>
                      <!-- ({{ pac }}) -->
                      <!-- ({{ pac.pac_id }}) -->
                      <!-- ({{ pac.contratado }}) -->
                      <!-- ({{ pac.vencido }}) -->
                      <!-- ({{ contratoCLU }}) -->
                      <div class="pac-testando" :class="((pac.contratado === 't' || (cpntClu === null && [ 'd', 'dv' ].indexOf(contratoCLU) !== -1)) === false && pac.contratado !== 't') ? '' : ([ 'd', 'dv' ].indexOf(contratoCLU) !== -1 || pac.contratado === 't' ? 'aviso-amarelo' : 'aviso-vermelho') + ([ '', null, undefined, '0' ].indexOf(pac.bilhetagem_valor) === -1 ? ' bilhetagem' : '')">
                        <template v-if="pac.contratado === 't' || (cpntClu === null && [ 'd', 'dv' ].indexOf(contratoCLU) !== -1)">
                          <template v-if="pac.vencido === 's' && contratoCLU !== 'd'">
                            Teste expirado
                          </template>
                          <template v-else-if="pac.vencido !== 's'">
                            Testando
                          </template>
                        </template>
                        <template v-else>
                          Contratado
                        </template>
                      </div>
                      <div class="pac-bilhetagem" v-if="[ '', null, undefined, '0' ].indexOf(pac.bilhetagem_valor) === -1">
                        Com Bilhetagem
                      </div>

                      <div class="bt-contratar" v-if="[ 'l', 'lv' ].indexOf(contratoCLU) !== -1 && cpntClu === null && pac.salvo !== false && (pac.contratado === 't' || (cpntClu === null && [ 'd', 'dv' ].indexOf(contratoCLU) !== -1)) && (pac.vencido === 's' && contratoCLU !== 'd') === false && pac.vencido !== 's'">
                        <App-Button :cpntClass="[ 'btn', 'btn-primary', 'btn-sm' ]" @onClick="() => { appConfigPacContratar(pac) }">Contratar</App-Button>
                      </div>

                      <table class="cfg-pac-valor" v-if="$store.state.token.usuario === 'SuporteRF' && (pac.contratado === 't' || (cpntClu === null && [ 'd', 'dv' ].indexOf(contratoCLU) !== -1))">
                        <tr>
                          <td style="width: 120px; text-align: right;">
                            <div>
                              <span title="Taxa de inscrição">TI: </span>&nbsp;
                            </div>
                          </td>
                          <td style="width: 100px;min-width: 100px;max-width: 100px;">
                            <div>
                              <App-Input
                              :cpntStatus="''"
                              :cpntNome="''"
                              :cpntMask="'valorMoeda'"
                              :cpntDisabled="inputsLimpar.indexOf(pac.pac_id + '_ti') !== -1"
                              :cpntValue="inputsLimpar.indexOf(pac.pac_id + '_ti') !== -1 ? '' : (inputs[pac.pac_id + '_ti'] === '' ? pac.ti_valor : inputs[pac.pac_id + '_ti'])"

                              :cpntOnChange="(value) => { appConfigPacOnChangeValor(value, pac.pac_id + '_ti') }"
                              ></App-Input>

                              <input type="checkbox" class="app-checkbox" :id="'ck_cfg_pac_' + pac.pac_id + '_ti'" :value="pac.pac_id + '_ti'" v-model="inputsLimpar">
                              <label :for="'ck_cfg_pac_' + pac.pac_id + '_ti'" :title="'Marque o checkbox caso deseje reinicializar o valor.'"></label>
                            </div>
                          </td>
                          <td style="text-align: left;">
                            <div>
                              &nbsp;
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td style="width: 120px; text-align: right;">
                            <div v-if="inputs[pac.pac_id] !== undefined">
                              <span title="LU Incluso">Valor: </span>&nbsp;
                            </div>
                          </td>
                          <td style="width: 100px;min-width: 100px;max-width: 100px;">
                            <div v-if="inputs[pac.pac_id] !== undefined">
                              <App-Input
                              :cpntStatus="''"
                              :cpntNome="''"
                              :cpntMask="'valorMoeda'"
                              :cpntDisabled="inputsLimpar.indexOf(pac.pac_id) !== -1"
                              :cpntValue="inputsLimpar.indexOf(pac.pac_id) !== -1 ? '' : (inputs[pac.pac_id] === '' ? pac.lu_valor : inputs[pac.pac_id])"

                              :cpntOnChange="(value) => { appConfigPacOnChangeValor(value, pac.pac_id) }"
                              ></App-Input>

                              <input type="checkbox" class="app-checkbox" :id="'ck_cfg_pac_' + pac.pac_id" :value="pac.pac_id" v-model="inputsLimpar">
                              <label :for="'ck_cfg_pac_' + pac.pac_id" :title="'Marque o checkbox caso deseje reinicializar o valor.'"></label>
                            </div>
                          </td>
                          <td style="text-align: left;">
                            <div v-if="inputs[pac.pac_id] !== undefined">
                              <template v-if="pac.pac_id === '37'">
                                &nbsp;/&nbsp;CLU Adicional&nbsp;/&nbsp;mês
                              </template>
                              <template v-else-if="pac.pac_id === '30'">
                                &nbsp;/&nbsp;GB&nbsp;/&nbsp;mês
                              </template>
                              <template v-else>
                                &nbsp;/&nbsp;mês
                              </template>
                            </div>
                          </td>
                        </tr>
                        <template v-if="[ '', null, undefined ].indexOf(pac.id_ser_int_bilhetagem) === -1">
                          <tr>
                            <td style="width: 120px; text-align: right;">
                              <div>
                                <span title="LU Incluso">Incluso: </span>&nbsp;
                              </div>
                            </td>
                            <td style="width: 100px;min-width: 100px;max-width: 100px;">
                              <div>
                                <App-Input
                                :cpntStatus="''"
                                :cpntNome="''"
                                :cpntDisabled="inputsLimpar.indexOf(pac.pac_id + '_lu_inc') !== -1"
                                :cpntValue="inputsLimpar.indexOf(pac.pac_id + '_lu_inc') !== -1 ? '' : (inputs[pac.pac_id + '_lu_inc'] === '' ? pac.lu_incluso : inputs[pac.pac_id + '_lu_inc'])"
  
                                :cpntOnChange="(value) => { appConfigPacOnChangeValor(value, pac.pac_id + '_lu_inc') }"
                                ></App-Input>
  
                                <input type="checkbox" class="app-checkbox" :id="'ck_cfg_pac_' + pac.pac_id + '_lu_inc'" :value="pac.pac_id + '_lu_inc'" v-model="inputsLimpar">
                                <label :for="'ck_cfg_pac_' + pac.pac_id + '_lu_inc'" :title="'Marque o checkbox caso deseje reinicializar o valor.'"></label>
                              </div>
                            </td>
                            <td style="text-align: left;">
                              <div>
                                &nbsp;
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td style="width: 120px; text-align: right;">
                              <div>
                                <span title="Valor Bilhetagem">Bilhetagem: </span>&nbsp;
                              </div>
                            </td>
                            <td style="width: 100px;min-width: 100px;max-width: 100px;">
                              <div>
                                <App-Input
                                :cpntStatus="''"
                                :cpntNome="''"
                                :cpntMask="'valorMoeda'"
                                :cpntDisabled="inputsLimpar.indexOf(pac.pac_id + '_bilhetagem') !== -1"
                                :cpntValue="inputsLimpar.indexOf(pac.pac_id + '_bilhetagem') !== -1 ? '' : (inputs[pac.pac_id + '_bilhetagem'] === '' ? pac.bilhetagem_valor : inputs[pac.pac_id + '_bilhetagem'])"
  
                                :cpntOnChange="(value) => { appConfigPacOnChangeValor(value, pac.pac_id + '_bilhetagem') }"
                                ></App-Input>
  
                                <input type="checkbox" class="app-checkbox" :id="'ck_cfg_pac_' + pac.pac_id + '_bilhetagem'" :value="pac.pac_id + '_bilhetagem'" v-model="inputsLimpar">
                                <label :for="'ck_cfg_pac_' + pac.pac_id + '_bilhetagem'" :title="'Marque o checkbox caso deseje reinicializar o valor.'"></label>
                              </div>
                            </td>
                            <td style="text-align: left;">
                              <div>
                                &nbsp;
                              </div>
                            </td>
                          </tr>
                        </template>
                      </table>

                      <!-- <div class="cfg-pac-valor">
                        <App-Input
                        :cpntStatus="''"
                        :cpntNome="''"
                        :cpntMask="'valorMoeda'"
                        :cpntValue="inputs[pac.pac_id] === undefined ? '' : inputs[pac.pac_id]"

                        :cpntOnChange="(value) => { appConfigPacOnChangeValor(value, pac.pac_id) }"
                        ></App-Input>
                        
                        <template v-if="pac.pac_id === '37'">
                          &nbsp;/&nbsp;CLU Adicional&nbsp;/&nbsp;mês
                        </template>
                        <template v-else-if="pac.pac_id === '30'">
                          &nbsp;/&nbsp;GB&nbsp;/&nbsp;mês
                        </template>
                        <template v-else>
                          &nbsp;/&nbsp;mês
                        </template>
                      </div>
                      <div class="cfg-pac-valor" v-if="[ '', null, undefined, '0', 0 ].indexOf(pac.ti_valor) === -1">
                        <App-Input
                        :cpntStatus="''"
                        :cpntNome="''"
                        :cpntMask="'valorMoeda'"
                        :cpntValue="inputs[pac.pac_id + '_ti'] === undefined ? '' : inputs[pac.pac_id + '_ti']"

                        :cpntOnChange="(value) => { appConfigPacOnChangeValor(value, pac.pac_id + '_ti') }"
                        ></App-Input>
                        
                        <template>
                          &nbsp; Taxa Inscrição
                        </template>
                      </div> -->
                    </li>
                  </ul>
                </td>
              </tr>
              <tr v-if="[ 'pag_setup', 'pag_setup_2', 'pag_setup_intencao' ].indexOf($route.name) === -1">
                <td rowspan="2">
                  <template v-if="$store.state.token.clu_mu === 'a' || ([ 'pag_setup', 'pag_setup_intencao' ].indexOf($route.name) !== -1 && cpntIntencao !== '')">
                    <!-- <div style="text-align: center; background-color: #d9e700; margin-top: -15px;  margin-bottom: 10px; padding: 5px 5px; border-radius: 6px; border-collapse: collapse; border-style: hidden; box-shadow: 0px 0px 0px 1px #c6c4c4;">
                      Solicite ao  Administrador da sua Licença de Uso para testar novos pacotes.
                    </div>
                  </template>
                  <template v-else> -->
                    <template v-if="$store.state.token.dep_plus === false">
                      <div v-if="cpntClu !== null && [ '', null, undefined ].indexOf(fatura) === -1" style="text-align: center;">
                        <RF-Button :data-time='time'
                          :cpntId='fatura.id'
                          :cpntStatus='fatura.status' 
                          :cpntTexto='fatura.texto' 
                          :cpntClass='fatura.class'
                          :cpntDisabled='fatura.disabled'
                          :cpntExplica='fatura.explica'

                          @onClickButton='fatura.onClick'
                        ></RF-Button>
                      </div>
                    
                      <template v-else-if='(cpntClu === null && (contratoCLU !== "l" && contratoCLU !== "lv")) || ([ "pag_setup", "pag_setup_intencao" ].indexOf($route.name) !== -1 && cpntIntencao !== "")'>
                      <!-- <template v-else> -->
                        <!-- ({{ arrMensagem   }}) -->
                        <template v-if='Object.keys(arrMensagem).length > 0'>
                          <p class="rf-titulo-pacote">
                            <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                            Ressaltando as informações de valores descritas no contrato de Licença de Uso.
                          </p>
                          <div class="rf-valor-pacote">
                            <template v-for='(valMsg, pacId) in arrMensagem'>
                              <p v-if="[ '25' ].indexOf(pacId) === -1 || ((pacId === '25' && (inputs['25_ti'] !== '' && Number(inputs['25_ti']) >= 1)) || (inputs['25_ti'] === '' && Number(pac25.ti_valor) >= 1))" v-html='valMsg' :key="pacId"></p>
                            </template>
                          </div>
                        </template>

                        <div class="rf-valor-pacote valores" style="padding-left: 0px;">
                          <template v-if="$store.state.token.contador === false || ($store.state.token.contador === true && (arrPacotesSelected.length !== 2 || arrPacotesSelected.filter(item => [ '1', '34' ].indexOf(item.pac_id) === -1).length >= 1) ) || ([ 'pag_setup', 'pag_setup_intencao' ].indexOf($route.name) !== -1 && cpntIntencao !== '')">
                            <App-Tabela-Totais v-if="cpntClu === null"
                            :cpntCluPcc="Object.keys(inputs)"
                            :cpntContratoCLU="contratoCLU"
                            :cpntTituloValorMensal="'Licença de uso'"
                            :cpntValorLicencaUso="valores.virtual_valor_pacote"
                            :cpntQtdeUsuarios="valores.virtual_n_ua"
                            :cpntValorUsuarios="valores.valor_ua"
                            :cpntQtdeContadorPlus="valores.virtual_n_cnpj_adicional"
                            :cpntValorContadorPlus="valores.valor_cnpj_adicional"
                            :cpntQtdeArmArquivos="valores.virtual_arm_arquivo_qtde_gb"
                            :cpntValorArmArquivos="valores.virtual_arm_arquivo_valor_por_gb"
                            :cpntQtdeSincronismo="valores.virtual_sincronizar_qtde"
                            :cpntValorSincronismo="valores.valor_sin_clu_adicional"
                            :cpntValorDesconto="valores.desconto"
                            :cpntTaxaInscricao="valores.virtual_valor_ti"
                            :cpntValorTotal="valores.virtual_total"

                            :cpntBilhetagem="Object.values(bilhetagem)"
                            :cpntValorFatura="valores.recorrenciaValorBruto"
                            :cpntValorTestando="valores.pacoteValorTestando"
                            :cpntValorDescontoTestando="valores.descontoTestando"
                            :cpntOnchangeValue="(value, chave) => { valores[chave] = value }"
                            ref='tabtotais'
                            ></App-Tabela-Totais>
                            <!-- virtual_sincronizar_qtde:  ({{ valores.virtual_sincronizar_qtde }})<br/>
                            valor_sin_clu_adicional:   ({{ valores.valor_sin_clu_adicional }})<br/>
                            virtual_sincronizar_valor: ({{ valores.virtual_sincronizar_valor }})<br/> -->
                            <!-- virtual_sincronizar_qtde: ({{ valores.virtual_sincronizar_qtde }})<br/> -->
                            <!-- ({{ Object.keys(valores) }}) -->

                            
                            <!-- <div>
                              <table class="cfg-valor">
                                <tr class="titulo">
                                  <td colspan="4">
                                    Valores licença de uso mensal
                                  </td>
                                </tr>
                                <tr class="titulo">
                                  <td class='nome'>
                                    Tipo
                                  </td>
                                  <td class='qtde'>
                                    Qtde
                                  </td>
                                  <td class='valor_uni'>
                                    Valor Uni.
                                  </td>
                                  <td class='valor_tot'>
                                    Valor Total
                                  </td>
                                </tr>
                                <tr>
                                  <td class='nome'>
                                    Licença de uso
                                  </td>
                                  <td class='qtde'>
                                    ---
                                  </td>
                                  <td class='valor_uni'>
                                    ---
                                  </td>
                                  <td class='valor_tot'>
                                    R$ {{ valores.virtual_valor_pacote.formatado }}
                                  </td>
                                </tr>
                                <tr>
                                  <td class='nome'>
                                    Usuário adicional
                                  </td>
                                  <td class='qtde'>
                                    {{ valores.virtual_n_ua }}
                                  </td>
                                  <td class='valor_uni'>
                                    <App-Input v-if="$store.state.token.usuario === 'SuporteRF'"
                                    :cpntStatus="''"
                                    :cpntNome="''"
                                    :cpntMask="'valorMoeda'"
                                    :cpntValue="valores.valor_ua.valor"

                                    :cpntOnChange="(value) => { appConfigPacOnChangeCampoValor(value, 'valor_ua') }"
                                    ></App-Input>
                                    <template v-else>
                                      R$ {{ valores.valor_ua.formatado }}
                                    </template>
                                  </td>
                                  <td class='valor_tot'>
                                    R$ {{ valores.valor_ua_total.formatado }}
                                  </td>
                                </tr>
                                <tr v-if="inputs['36'] !== undefined">
                                  <td class='nome'>
                                    CNPJ Adicional
                                  </td>
                                  <td class='qtde'>
                                    {{ valores.virtual_n_cnpj_adicional }}
                                  </td>
                                  <td class='valor_uni'>
                                    <App-Input v-if="$store.state.token.usuario === 'SuporteRF'"
                                    :cpntStatus="''"
                                    :cpntNome="''"
                                    :cpntMask="'valorMoeda'"
                                    :cpntValue="valores.valor_cnpj_adicional.valor"

                                    :cpntOnChange="(value) => { appConfigPacOnChangeCampoValor(value, 'valor_cnpj_adicional') }"
                                    ></App-Input>
                                    <template v-else>
                                      R$ {{ valores.valor_cnpj_adicional.formatado }}
                                    </template>
                                  </td>
                                  <td class='valor_tot'>
                                    R$ {{ valores.valor_cnpj_adicional_total.formatado }}
                                  </td>
                                </tr>
                                <tr v-if="inputs['30'] !== undefined">
                                  <td class='nome'>
                                    Arm. Arquivos
                                  </td>
                                  <td class='qtde'>
                                    {{ valores.virtual_arm_arquivo_qtde_gb }} / GB
                                  </td>
                                  <td class='valor_uni'>
                                    R$ {{ valores.virtual_arm_arquivo_valor_por_gb.formatado }}
                                  </td>
                                  <td class='valor_tot'>
                                    R$ {{ valores.virtual_arm_arquivo_valor_por_gb_total.formatado }}
                                  </td>
                                </tr>
                                <tr v-if="inputs['37'] !== undefined">
                                  <td class='nome'>
                                    Sincronismo
                                  </td>
                                  <td class='qtde'>
                                    {{ valores.virtual_sincronizar_qtde }}
                                  </td>
                                  <td class='valor_uni'>
                                    R$ {{ valores.virtual_sincronizar_valor.formatado }}
                                  </td>
                                  <td class='valor_tot'>
                                    R$ {{ valores.virtual_sincronizar_valor_total.formatado }}
                                  </td>
                                </tr>
                                <tr v-if="[ '', null, undefined, '0' ].indexOf(valores.desconto.valor) === -1 || $store.state.token.usuario === 'SuporteRF'">
                                  <td class='nome'>
                                    Desconto
                                  </td>
                                  <td class='qtde'>
                                    ---
                                  </td>
                                  <td class='valor_uni'>
                                    ---
                                  </td>
                                  <td class='valor_tot'>
                                    <App-Input v-if="$store.state.token.usuario === 'SuporteRF'"
                                    :cpntStatus="''"
                                    :cpntNome="''"
                                    :cpntMask="'valorMoeda'"
                                    :cpntValue="valores.desconto.valor"

                                    :cpntOnChange="(value) => { appConfigPacOnChangeCampoValor(value, 'desconto') }"
                                    ></App-Input>
                                    <template v-else>
                                      - R$ {{ valores.desconto.formatado }}
                                    </template>
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="3" class="total_nome">
                                    <b>Total mensal: </b>
                                  </td>
                                  <td class="total_valor">
                                    R$ {{ configPacCalcularTotalMensal }}
                                  </td>
                                </tr>

                                <tr>
                                  <td colspan="4" class="divisao">
                                    &nbsp;
                                  </td>
                                </tr>

                                <tr class="titulo">
                                  <td colspan="4">
                                    Taxas e valores adicionais
                                  </td>
                                </tr>

                                <tr>
                                  <td class='nome' colspan="3">
                                    Taxa Inscrição
                                  </td>
                                  <td class='valor_tot'>
                                    R$ {{ valores.virtual_valor_ti.formatado }}
                                  </td>
                                </tr>
                              </table>
                            </div> -->

                            <div class="aviso-setup">
                              Você esta no período de testes, os valores acima são apenas para conhecimento e só serão cobrados caso efetue o aceite do contrato de Licença de Uso.
                            </div>
                          </template>





























                          <!-- <table style="width: 100%;">
                            <tr>
                              <td style="width: 70%; text-align: right; padding: 5px 0px;"><b>Taxa inscrição:</b></td>
                              <td style="width: 30%; text-align: right; padding: 5px 0px;" colspan="2">{{ valSimbolo }} {{ valTax }}</td>
                            </tr>

                            <tr>
                              <td colspan="3" style="padding: 0px;">
                                <hr style="margin: 2px 0px; padding: 0px; width: 100%;"/>
                              </td>
                            </tr>

                            <tr>
                              <td style="width: 70%; text-align: right; padding: 5px 0px;"><b>Pacotes:</b></td>
                              <td style="width: 30%; text-align: right; padding: 5px 0px;" colspan="2">{{ valSimbolo }} {{ valLic }}</td>
                            </tr>

                            <tr>
                              <td style="width: 70%; text-align: right; padding: 5px 0px;"><b>Usuários Adicionais:</b></td>
                              <td style="width: 30%; text-align: right; padding: 5px 0px;" colspan="2"><span style="font-size: 13px;">(2)&nbsp;</span> {{ valSimbolo }} 20,00</td>
                            </tr>

                            <tr>
                              <td colspan="3" style="padding: 0px;">
                                <hr style="margin: 2px 0px; padding: 0px; width: 100%;"/>
                              </td>
                            </tr>

                            <tr>
                              <td style="width: 70%; text-align: right; padding: 5px 0px;"><b>Desconto:</b></td>
                              <td style="width: 30%; text-align: right; padding: 5px 0px;" colspan="2">-R$ 20,00</td>
                            </tr>

                            <tr>
                              <td colspan="3" style="padding: 0px;">
                                <hr style="margin: 2px 0px; padding: 0px; width: 100%;"/>
                              </td>
                            </tr>

                            <tr>
                              <td style="width: 70%; text-align: right; padding: 5px 0px;"><b>Total licença de uso:</b></td>
                              <td style="width: 30%; text-align: right; padding: 5px 0px;">R$ 89,90</td>
                              <td style="padding: 5px 0px;">&nbsp;/&nbsp;mês</td>
                            </tr>
                          </table>
                          <br/>
                          <br/>
                          <br/>
                          <br/>
                          <br/>
                          <br/>
                          <br/>
                          <br/>
                          <br/>
                          <br/> -->

                          <!-- <template v-if="$store.state.token.contador === false || ($store.state.token.contador === true && (arrPacotesSelected.length !== 2 || arrPacotesSelected.filter(item => [ '1', '34' ].indexOf(item.pac_id) === -1).length >= 1) ) || ([ 'pag_setup', 'pag_setup_intencao' ].indexOf($route.name) !== -1 && cpntIntencao !== '')">
                            <table style="width: 100%;">
                              <tr>
                                <td style="width: 60%; text-align: right; padding: 5px 0px;"><b>Taxa Inscrição:</b></td>
                                <td style="width: 40%; text-align: left; padding: 5px 0px 0px 8px;">{{ valSimbolo }} {{ valTax }}
                                <!- </td>
                                <td style="width: 10%; padding: 5px 0px;"> ->
                                  &nbsp;</td>
                              </tr>
                              <tr>
                                <td style="width: 60%; text-align: right; padding: 5px 0px;"><b>Licença de Uso:</b></td>
                              <td style="width: 40%; text-align: left; padding: 5px 0px 0px 8px;">{{ valSimbolo }} {{ valLic }}
                                <!- </td>
                                <td style="width: 10%; padding: 5px 0px;"> ->
                                  &nbsp;/&nbsp;mês</td>
                              </tr>
                              <tr v-if="pac30 !== null">
                                <td style="width: 60%; text-align: right; padding: 5px 0px;"><b style="text-transform: capitalize">{{ pac30._pac_nome }}:</b></td>
                                <td style="width: 40%; text-align: left; padding: 5px 0px 0px 8px;">{{ valSimbolo }} {{ pac30._lu_valor }}
                                <!- </td> -->
                                <!-- <td style="width: 10%; padding: 5px 0px;"> ->
                                  &nbsp;/&nbsp;GB&nbsp;/&nbsp;mês</td>
                              </tr>
                              <tr v-if="pac37 !== null">
                                <td style="width: 60%; text-align: right; padding: 5px 0px;"><b style="text-transform: capitalize">{{ pac37._pac_nome }}:</b></td>
                                <td style="width: 40%; text-align: left; padding: 5px 0px 0px 8px;">{{ valSimbolo }} {{ pac37._lu_valor }}&nbsp;/&nbsp;CLU Adicional&nbsp;/&nbsp;mês</td>
                              </tr>
                              <tr>
                                <td style="width: 60%; text-align: right; padding: 5px 0px;"><b>Usuário adicional:</b></td>
                                <td style="width: 40%; text-align: left; padding: 5px 0px 0px 8px;">{{ valSimbolo }} 
                                  <App-Input v-if="$store.state.token.usuario === 'SuporteRF'"
                                  :cpntStatus="''"
                                  :cpntNome="''"
                                  :cpntMask="'valorMoeda'"
                                  :cpntValue="valUsu"

                                  :cpntOnChange="(value) => { appConfigPacOnChangeCampoValor(value, 'valUsu') }"
                                  ></App-Input>
                                  <template v-else>{{ valUsu }}</template>
                                <!- </td>
                                <td style="width: 10%; padding: 5px 0px;"> ->
                                  &nbsp;/&nbsp;mês</td>
                              </tr>
                              <tr v-if="valCnpjAdiconal !== ''">
                                <!- ({{ pac36 }}) ->
                                <td style="width: 60%; text-align: right; padding: 5px 0px;"><b style="text-transform: capitalize">CLU adicional contador plus:</b></td>
                                <td style="width: 40%; text-align: left; padding: 5px 0px 0px 8px;">{{ valSimbolo }} 
                                  <App-Input v-if="$store.state.token.usuario === 'SuporteRF'"
                                  :cpntStatus="''"
                                  :cpntNome="''"
                                  :cpntMask="'valorMoeda'"
                                  :cpntValue="valCnpjAdiconal"

                                  :cpntOnChange="(value) => { appConfigPacOnChangeCampoValor(value, 'valCnpjAdiconal') }"
                                  ></App-Input>
                                  <template v-else>{{ valCnpjAdiconal }}</template>&nbsp;/&nbsp;mês</td>
                              </tr>
                              <tr v-if="valDesconto !== ''">
                                <!- ({{ pac36 }}) ->
                                <td style="width: 60%; text-align: right; padding: 5px 0px;"><b style="text-transform: capitalize">Desconto:</b></td>
                                <td style="width: 40%; text-align: left; padding: 5px 0px 0px 8px;">- {{ valSimbolo }} 
                                  <App-Input v-if="$store.state.token.usuario === 'SuporteRF'"
                                  :cpntStatus="''"
                                  :cpntNome="''"
                                  :cpntMask="'valorMoeda'"
                                  :cpntValue="valDesconto"

                                  :cpntOnChange="(value) => { appConfigPacOnChangeCampoValor(value, 'valDesconto') }"
                                  ></App-Input>
                                  <template v-else>{{ valDesconto }}</template>
                                  &nbsp;/&nbsp;mês</td>
                              </tr>
                            </table>
    
                            <div class="aviso-setup">
                              Você esta no período de testes, os valores acima são apenas para conhecimento e só serão cobrados caso efetue o aceite do contrato de Licença de Uso.
                            </div>
                          </template> -->
                        </div>
                        <br/>
                      </template>
                      <template v-else-if="cpntClu === null">
                        <div v-if="[ '', null, undefined ].indexOf(fatura) === -1" style="text-align: center; margin-top: -10px; margin-bottom: 10px;">
                          <RF-Button :data-time='time'
                            :cpntId='fatura.id'
                            :cpntStatus='fatura.status' 
                            :cpntTexto='fatura.texto' 
                            :cpntClass='fatura.class'
                            :cpntDisabled='fatura.disabled'
                            :cpntExplica='fatura.explica'

                            @onClickButton='fatura.onClick'
                          ></RF-Button>
                        </div>
                        
                        <!-- <App-Tabela-Totais
                        :cpntCluPcc="Object.keys(inputs)"
                        :cpntValorLicencaUso="valores.recorrenciaValorBruto"
                        :cpntValorSincronismo="valores.virtual_sincronizar_valor"
                        :cpntTaxaInscricao="valores.virtual_valor_ti"
                        :cpntValorTestando="valores.pacoteValorTestando"
                        :cpntValorDesconto="valores.desconto"
                        :cpntOnchangeValue="(value, chave) => { valores[chave] = value }"
                        ></App-Tabela-Totais> -->

                        <App-Tabela-Totais
                        :cpntCluPcc="Object.keys(inputs)"
                        :cpntContratoCLU="contratoCLU"
                        :cpntTituloValorMensal="[ '', null, undefined ].indexOf(valores.recorrenciaValorBruto) !== -1 ? 'Licença de uso' : 'Fatura'"
                        :cpntValorLicencaUso="valores.recorrenciaValorBruto"
                        :cpntQtdeUsuarios="valores.virtual_n_ua"
                        :cpntValorUsuarios="valores.valor_ua"
                        :cpntQtdeContadorPlus="valores.virtual_n_cnpj_adicional"
                        :cpntValorContadorPlus="pac36 !== null && pac36.contratado !== 't' ? '' : valores.valor_cnpj_adicional"
                        :cpntQtdeArmArquivos="valores.virtual_arm_arquivo_qtde_gb"
                        :cpntValorArmArquivos="pac30 !== null && pac30.contratado !== 't' ? '' : valores.virtual_arm_arquivo_valor_por_gb"
                        :cpntQtdeSincronismo="valores.virtual_sincronizar_qtde"
                        :cpntValorSincronismo="pac37 !== null && pac37.contratado !== 't' ? '' : valores.valor_sin_clu_adicional"
                        :cpntValorDesconto="valores.recorrenciaValorDesconto"
                        :cpntTaxaInscricao="valores.pacoteTiValorTestando"
                        :cpntValorTotal="valores.virtual_total"
                        
                        :cpntBilhetagem="Object.values(bilhetagem)"
                        :cpntValorFatura="valores.recorrenciaValorBruto"
                        :cpntValorTestando="valores.pacoteValorTestando"
                        :cpntValorDescontoTestando="valores.descontoTestando"
                        :cpntOnchangeValue="(value, chave) => { valores[chave] = value }"
                        ref='tabtotais'
                        ></App-Tabela-Totais>
                        <!-- :cpntOnchangeValue="(value, chave) => { valores[chave] = value }" -->
                          <!-- ({{ valores }}) -->
                        <br/>
                      </template>
                    </template>
                    
                    <template v-if="cpntClu === null">
                      <template v-if='$store.state.token.dep_plus === false && (contratoCLU === "l" || contratoCLU === "lv")'>
                        <p>
                          <i class="fa fa-exclamation-triangle rf-icon-amarelo" aria-hidden="true" style="vertical-align: 0px; font-size: var(--font-base-soma-20);"></i>
                          Informe senha da conta <b>{{ $store.state.token.conta }}</b>:
                        </p>

                        <!-- <RF-Input v-if='inputSenha.tipo === "input"' :class='"class-time-" + time + " rf-inputSenha-tamanho-" + (inputSenha.hasOwnProperty("tamanho") ? inputSenha.tamanho : 0)' -->

                        <RF-Input :class='"class-time-" + time + " rf-field-tamanho-" + (inputSenha.hasOwnProperty("tamanho") ? inputSenha.tamanho : 0) + " rf-field-inputSenha"'
                          :cpntStatus='inputSenha.status'
                          :cpntId='inputSenha.id'
                          :cpntNome='inputSenha.nome'
                          :cpntValue='inputSenha.value'
                          :cpntType='inputSenha.type'
                          :cpntAutoComplete='inputSenha.autocomplete'
                          :cpntMask='inputSenha.mask'
                          :cpntDisabled='inputSenha.disabled'
                          :cpntMostrar='inputSenha.mostrar'
                          :cpntAutoFocus='inputSenha.autofocus'
                          :cpntMensagem='inputSenha.mensagem'
                          :cpntMensagemTipo='inputSenha.mensagemTipo'
                          :cpntPlaceholder='inputSenha.placeholder'

                          :cpntOnChange='onChangePassword'
                          :ref='"inputSenha"'
                        ></RF-Input>
                      </template>

                      <div class="rf-valor-pacote" v-if="booAlteraPacote === true">
                        <p style="text-align: center; padding: 10px 0px">
                          <RF-Button v-if="flag === true" :data-time='time'
                            :cpntId='"salvar-pacotes"'
                            :cpntStatus='statusBt' 
                            :cpntTexto='[ "pag_setup", "pag_setup_intencao" ].indexOf($route.name) === -1 ? "Atualizar Pacotes" : "Quero conhecer o Rotina Fácil!"' 
                            :cpntClass='[ "btn", "btn-primary" ]'
                            :cpntDisabled='disabledBt'
                            :cpntExplica='explicaBt'

                            @onClickButton='onAtualizarPacotes'
                          ></RF-Button>
                        </p>
                      </div>
                    </template>
                  </template>
                </td>
              </tr>
            </table>
          </div>
        </template>

      </div>
    </template>

    <App-Pacotes-Vencidos-Novo v-if="contratar !== null"
    :cpntPacoteIds="contratar"
    :cpntFecharFormulario="appConfigPacContratarFechar"
    ></App-Pacotes-Vencidos-Novo>
  </div>
</template>

<style scoped>
  .rf-config-pacotes {
    padding: 15px 20px 15px 20px !important;
  }

  .rf-loading-form {
    text-align: center;
    padding: 30px 0px 30px 0px;
  }
    .rf-loading-form > svg {
      font-size: var(--font-base-soma-90);
      color: var(--color-base-05);
    }
    .rf-loading-form > div {
      margin-top: 15px;
    }
  /* -------------------------------------- */

  .rf-pacotes {
    width: 870px;
  }

  .rf-titulo-pacote {
    padding-top: 15px;
    font-weight: bold;
  }
  .rf-valor-pacote {
    padding-left: 15px;    
  }
    .rf-valor-pacote > p {
      text-align: justify;
    }

  .rf-config-pacotes > .rf-valor-pacote > .rf-pacote {
    height: 40px;
    vertical-align: middle;
    margin-right: 10px;
    display: inline-block;
  }

  .rf-valor-pacote > table {
    width: 100%;
  }
    .rf-valor-pacote > table > tr > td {
      padding: 5px 5px;
      vertical-align: top;
    }
    .rf-valor-pacote > table > tr > td:nth-last-child(1) {
      width: 47.5%;
    }
    .rf-valor-pacote > table > tr > td:nth-last-child(2) {
      width: 5%;
    }
    .rf-valor-pacote > table > tr > td:nth-last-child(3) {
      width: 47.5%;
    }
      .rf-valor-pacote > table > tr > td > ul {
        /* border: 1px solid #ccc; */
        /* min-height: 45px; */
      }
        .rf-valor-pacote > table > tr > td > ul > li.alert-warning {
          margin-bottom: 0px;
        }
        .rf-valor-pacote > table > tr > td > ul > li {
          /* min-height: 45px; */
          vertical-align: middle !important;
        }
          .rf-valor-pacote > table > tr > td > ul > li > div {
            /* height: 30px; */
            width: 66%;
            padding-left: 15px;
            vertical-align: middle !important;
          }
          .rf-valor-pacote > table > tr > td > ul > li > div, .rf-valor-pacote > table > tr > td > ul > li > button {
            display: inline-block;
          }
    .rf-valor-pacote > table > tr > td > ul > li > .pac-testando {
      width: 100px;
      max-width: 100px;
      height: 20px;
      position: absolute;
      top: -1px;
      right: 0px;
      background: #e9e9e9;
      border: 1px solid #ccc;
      border-right: none;
      text-align: center;
      font-size: 12px;
      padding: 2px;
      font-weight: bold;
    }
    .rf-valor-pacote > table > tr > td > ul > li > .pac-testando:not(.bilhetagem) {
      border-bottom-left-radius: 5px;
    }
    .rf-valor-pacote > table > tr > td > ul > li > .pac-bilhetagem {
      width: 100px;
      max-width: 100px;
      height: 20px;
      position: absolute;
      top: 18px;
      right: 0px;
      background: #e9e9e9;
      border: 1px solid #ccc;
      border-bottom-left-radius: 5px;
      border-right: none;
      text-align: center;
      font-size: 12px;
      padding: 2px;
      font-weight: bold;
    }

      .rf-valor-pacote > table > tr > td > ul > li > .pac-testando.aviso-amarelo {
        background-color: #f4f1c3;
      }
      .rf-valor-pacote > table > tr > td > ul > li > .pac-testando.aviso-vermelho {
        background-color: #f7c6c6;
      }

      .rf-valor-pacote > table > tr > td > div.cpnt-app-input {
        width: 70px;
        vertical-align: 0px;
      }
  .aviso-setup {
    text-align: center;
    background-color: #d9e700;
    border: 1px solid #c6c4c4;
    border-radius: 5px;
    padding: 5px;
    margin-top: 15px;
  }

  .cfg-pac-valor {
    width: 100%;
    /* border-collapse: separate; */
    margin-top: 10px;
  }
    .cfg-pac-valor > tr > td {
      max-width: 50%;
    }
      .cfg-pac-valor > tr > td {
        padding: 5px;
        background: #e9e9e9;
        border: 1px solid #ccc;
        border-radius: 3px;
        width: 175px;
        max-width: 175px;
        margin: 0px auto;
        text-align: center;
      }
        .cfg-pac-valor > tr > td > div > div {
          width: calc(100% - 30px);
          vertical-align: -2px;
          text-align: center;
        }
  .valores > div > table.cfg-valor {
    width: 100%;
  }
    .valores > div > table.cfg-valor > tr.titulo > td {
      font-weight: bold;
      background: #e9e9e9;
      text-align: center !important;
    }
    .valores > div > table.cfg-valor > tr > td {
      border: 1px solid #ccc;
      padding: 3px 5px;
    }
    .valores > div > table.cfg-valor > tr > td.nome {
      width: calc(100% - 270px);
      text-align: left;
    }
    .valores > div > table.cfg-valor > tr > td.qtde {
      width: 90px;
      max-width: 90px;
      text-align: center;
    }
    .valores > div > table.cfg-valor > tr > td.valor_uni {
      width: 90px;
      max-width: 90px;
      text-align: center;
    }
    .valores > div > table.cfg-valor > tr > td.valor_tot {
      width: 90px;
      max-width: 90px;
      text-align: right;
    }
    .valores > div > table.cfg-valor > tr > td.divisao,
    .valores > div > table.cfg-valor > tr > td.total_nome {
      text-align: right;
      border: none !important;
    }
    .valores > div > table.cfg-valor > tr > td.total_valor {
      text-align: right;
      font-weight: bold;
    }

  .bt-contratar {
    /* float: right;
    text-align: right; */

    width: 100px;
    max-width: 100px;
    height: 20px;
    position: absolute;
    bottom: 13px;
    right: -8px;
    /* background: #e9e9e9; */
    /* border: 1px solid #ccc;
    border-bottom-left-radius: 5px;
    border-right: none;
    text-align: center;
    font-size: 12px;
    padding: 2px;
    font-weight: bold; */
  }
  .rf-valor-pacote > table > tr > td > ul > li > .pac-testando.bilhetagem ~ .cfg-pac-valor {
    margin-bottom: 30px;
  }

  .rf-valor-pacote > table > tr > td > ul > li > .pac-testando:not(.bilhetagem) ~ .bt-contratar {
    position: absolute;
    top: 22px !important;
  }
  .rf-valor-pacote > table > tr > td > ul > li > .pac-testando.bilhetagem ~ .tamanho-li {
    height: 100px !important;
  }
</style>

<style>
  .rf-config-pacotes > .rf-valor-pacote > .rf-pacote > .toggle {
    min-width: 180px;
  }
  .qtip-info-pacote {
    width: 420px !important;
    max-width: 420px !important;
  }
    .qtip-info-pacote > .qtip-content > table {
      width: 100%;
    }
      .qtip-info-pacote > .qtip-content > table > tbody > tr > td {
        padding: 3px;
      }

      .cfg-pac-valor > tr > td > div > div > input {
        text-align: center;
      }
</style>

<script>
  import { SESSAO_ATUALIZAR_TOKEN } from '@/assets/js/Sessao.js'
  import moment from 'moment'

  export default {
    components: {
      'App-Pacotes-Vencidos-Novo': () => import('@/components/config/pacotes/RF-Pacotes-Vencidos-Novo.vue'),
      'RF-Input': () => import('@/components/rf-geral/input/RF-Input.vue'),
      'RF-Explica': () => import('@/components/rf-geral/explica/RF-Explica.vue'),
      'App-Tabela-Totais': () => import('@/components/config/Tabela-Totais.vue')
    },
    props: {
      booAlteraPacote: {
        type: Boolean,
        required: false,
        default: true
      },
      cpntClu: {
        require: false,
        default: function () {
          return null
        }
      },
      cpntFecharFormulario: {
        require: false,
        default: function () {
          return null
        }
      },

      // FUNÇÕES PARA TELA DE CADASTRO
      cpntIntencao: {
        require: false,
        default: function () {
          return ''
        }
      },
      cpntFecharAtualizar: {
        require: false,
        default: function () {
          return null
        }
      }
    },
    data: function () {
      return {
        time: '',
        flag: true,
        statusBt: '',
        disabledBt: false,
        explicaBt: null,
        status: '',
        valSimbolo: 'R$',
        valLic: '',
        valUsu: '',
        valCnpjAdiconal: '',
        valDesconto: '',
        valTax: '',
        contratar: null,

        arrMensagem: {},

        arrPacotes: [],
        arrPacotesSelected: [],
        arrPacDivergente: [],
        pac25: null,
        pac30: null,
        pac36: null,
        pac37: null,
        hashPac: null,
        bilhetagem: {},

        valConta: 0,
        contratoCLU: '',
        inputs: {},
        inputsLimpar: [],

        inputSenha: {
          status: '',
          tamanho: 2,
          id: 'rf-pac-password',
          tipo: 'input',
          type: 'password',
          nome: '',
          value: '',
          api: 'senha',
          autofocus: false,
          mensagem: '',
          mensagemTipo: '',
          mostrar: true
        },
        fatura: '',
        valores: null
      }
    },
    mounted: function () {
      this.getPacotesExistentes()
    },
    methods: {
      appConfigPacBuscarContrato: function (callback) {
        // INICIA A VARIAVEL
        var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, field: { clu: null } }

        // SETA O CAMPO QUE DEVE GERAR
        queryGet.field_virtual = [ 'clu_con' ]

        // SETA O WHERE
        queryGet.where = { f: 'clu', o: '=', v: this.cpntClu }

        // FAZ A COMUNICAÇÃO COM A API
        this.$store.state.comunicaAPI('/subase/cli-rotinafacil/get', 'POST', queryGet, (retorno) => {
          // SETA OS DADOS DA CLU ATUAL
          this.contratoCLU = retorno.data[0].virtual_clu_con

          // EXECUTA O CALLBACK RECEBIDO
          callback()
        }, (apiError) => {
          this.status = apiError
        })
      },
      getPacotesExistentes: function () {
        var self = this

        var pacotes = []
        self.inputsLimpar = []
        self.inputs = {}
        self.arrPacotes = []
        self.arrPacotesSelected = []
        self.arrPacDivergente = []

        // CHAMA A FUNÇÃO PARA TRATAR OS VALORER SELECIONADOS
        this.appConfigPacTratarValores()

        // SETA A VARIAVEL
        var buscarInformcoes = (callback) => { callback() }

        // SETA O STATUS DE CARREGANDO SELECT
        self.status = 'carregando'

        // INICIA A ROTA DE DADOS
        var route = '/subase/pacote/get'

        // SETA OS DADOS DA CLU ATUAL
        self.contratoCLU = this.$store.state.token.clu_con

        // SETA A ROTA QUE DE DEVE BUSCAR
        if (self.cpntClu !== null) {
          // SETA A ROTA QUE DEVE CHAMAR
          route = '/subase/painel/pacote/get/' + self.cpntClu

          // SETA A FUNÇÃO QUE DEVE CHAMAR
          buscarInformcoes  = (callback) => { this.appConfigPacBuscarContrato(callback) }
        } else if (self.cpntFecharAtualizar !== '' && ([ '', null, undefined ].indexOf(this.$store.state.token) !== -1 || Object.keys(this.$store.state.token).length === 0)) {
          // SETA O NOME DA ROTA QUE DEVE CHAMAR
          route = '/subase/cadastro/pacote/get'

          // SETA OS PACOTES PADRÕES PARA COMEÇAR
          pacotes = [ 1, 21, 17 ]
            
          // VERIFICA O PACOTE QUE TEM QUE COLOCAR PARA CADA INTENÇÃO
          switch (self.cpntIntencao) {
            case 'oficina':
              pacotes = pacotes.concat([ 4, 6, 8, 15, 20, 23, 25 ])
              break

            case 'petshop':
              pacotes = pacotes.concat([ 4, 6, 28, 15, 20, 23, 25 ])
              break

            case 'contadorplus':
              pacotes = pacotes.concat([ 6, 15, 20, 23, 25, 30, 34, 36 ])
              break

            default:
              pacotes = pacotes.concat([ 4, 6, 20, 23 ])
              break
          }

          // SETA O TIPO DE CONTRATO
          self.contratoCLU = 'd'
        }

        // FAZ A COMUNICAÇÃO COM A API
        self.$store.state.comunicaAPI(route, 'GET', null, function (apiSuccess) {
          buscarInformcoes(() => {
            self.bilhetagem = {}

            // CARREGA O BOTÃO 
            var template = document.createElement('template')
            
            // LIMPA OS DADOS EXISTENTES
            self.fatura = ''

            // apiSuccess.desconto = '2500'

            // // SETA O VALOR DO USUARIO ADICIONAL
            // self.valUsu = '0,00'
            // if ([ '', null, undefined, '0', '0,0', '0,00', 0 ].indexOf(apiSuccess.valor_ua) === -1) {
            //   self.valUsu = self.$store.state.FUN_MASK_VALOR('valorMoeda', apiSuccess.valor_ua.toString())
            // }

            // // SETA O VALOR DO USUARIO ADICIONAL
            // self.valDesconto = ''
            // if ([ '', null, undefined, '0', '0,0', '0,00', 0 ].indexOf(apiSuccess.desconto) === -1) {
            //   self.valDesconto = self.$store.state.FUN_MASK_VALOR('valorMoeda', apiSuccess.desconto.toString())
            // }

            // // SETA O VALOR DO USUARIO ADICIONAL
            // self.valCnpjAdiconal = ''
            // if ([ '', null, undefined, '0', '0,0', '0,00', 0 ].indexOf(apiSuccess.valor_cnpj_adicional) === -1) {
            //   self.valCnpjAdiconal = self.$store.state.FUN_MASK_VALOR('valorMoeda', apiSuccess.valor_cnpj_adicional.toString())
            // }

            // self.valores.valor_ua.valor = apiSuccess.valor_ua
            // self.valores.valor_ua.formatado = self.$store.state.FUN_MASK_VALOR('valorMoeda', self.valores.valor_ua.valor.toString())

            // self.valores.desconto.valor = apiSuccess.desconto
            // self.valores.desconto.formatado = self.$store.state.FUN_MASK_VALOR('valorMoeda', self.valores.desconto.valor.toString())
            
            // self.valores.virtual_n_ua = apiSuccess.virtual_n_ua
            // self.valores.virtual_n_cnpj_adicional = apiSuccess.virtual_n_cnpj_adicional
            // self.valores.virtual_arm_arquivo_qtde_gb = apiSuccess.virtual_arm_arquivo_qtde_gb
            // self.valores.virtual_sincronizar_qtde = apiSuccess.virtual_sincronizar_qtde

            // self.valores.virtual_valor_ti.valor = apiSuccess.virtual_valor_ti
            // self.valores.virtual_valor_ti.formatado = self.$store.state.FUN_MASK_VALOR('valorMoeda', self.valores.virtual_valor_ti.valor.toString())

            // self.valores.virtual_valor_pacote.valor = apiSuccess.virtual_valor_pacote
            // self.valores.virtual_valor_pacote.formatado = self.$store.state.FUN_MASK_VALOR('valorMoeda', self.valores.virtual_valor_pacote.valor.toString())

            // self.valores.virtual_arm_arquivo_valor_por_gb.valor = apiSuccess.virtual_arm_arquivo_valor_por_gb
            // self.valores.virtual_arm_arquivo_valor_por_gb.formatado = self.$store.state.FUN_MASK_VALOR('valorMoeda', self.valores.virtual_arm_arquivo_valor_por_gb.valor.toString())
            
            // self.valores.valor_ua_total.valor = (Number(self.valores.valor_ua.valor) * Number(self.valores.virtual_n_ua)).toString()
            // self.valores.valor_ua_total.formatado = self.$store.state.FUN_MASK_VALOR('valorMoeda', self.valores.valor_ua_total.valor.toString())

            // self.valores.valor_cnpj_adicional_total.valor = (Number(self.valores.valor_cnpj_adicional.valor) * Number(self.valores.virtual_n_cnpj_adicional)).toString()
            // self.valores.valor_cnpj_adicional_total.formatado = self.$store.state.FUN_MASK_VALOR('valorMoeda', self.valores.valor_cnpj_adicional_total.valor.toString())

            // self.valores.virtual_sincronizar_valor.valor = apiSuccess.virtual_sincronizar_valor
            // self.valores.virtual_sincronizar_valor.formatado = self.$store.state.FUN_MASK_VALOR('valorMoeda', self.valores.virtual_sincronizar_valor.valor.toString())

            // self.valores.virtual_sincronizar_valor_total.valor = (Number(self.valores.virtual_sincronizar_valor.valor) * Number(self.valores.virtual_sincronizar_qtde)).toString()
            // self.valores.virtual_sincronizar_valor_total.formatado = self.$store.state.FUN_MASK_VALOR('valorMoeda', self.valores.virtual_sincronizar_valor_total.valor.toString())
            
            // self.valores.virtual_arm_arquivo_valor_por_gb.valor = apiSuccess.virtual_arm_arquivo_valor_por_gb
            // self.valores.virtual_arm_arquivo_valor_por_gb.formatado = self.$store.state.FUN_MASK_VALOR('valorMoeda', self.valores.virtual_arm_arquivo_valor_por_gb.valor.toString())

            // self.valores.virtual_arm_arquivo_valor_por_gb_total.valor = Number(((Number(self.valores.virtual_arm_arquivo_valor_por_gb.valor) / 100) * Number(self.valores.virtual_arm_arquivo_qtde_gb)).toFixed(2)) * 100
            // self.valores.virtual_arm_arquivo_valor_por_gb_total.formatado = self.$store.state.FUN_MASK_VALOR('valorMoeda', self.valores.virtual_arm_arquivo_valor_por_gb_total.valor.toString())
            // if (self.$store.state.token.usuario === 'SuporteRF' && apiSuccess.desconto === undefined) {
            //   apiSuccess.desconto = '0'
            // }

            self.valores = apiSuccess
  
            // CRIA O BOTÃO
            template.innerHTML = apiSuccess.fatura
            var button = template.content.childNodes[0]
  
            // VERIFICA SE TEM QUE SETAR ALGUM BOTÃO
            if ([ '', null, undefined ].indexOf(button) === -1) {
              self.fatura = {
                tipo: 'button',
                tipoButton: 'texto',
                id: 'clu-pacotes-fatura',
                status: '',
                class: 'btn btn-sm btn-info',
                link: button.href,
                texto: button.textContent || button.innerText || '',
                explica: (button.title !== undefined && button.title !== '') ? { mensagem: button.title } : null,
                onClick: function () { self.$store.state.WEB_WINDOW_OPEN(self.fatura.link, '_blank') }
              }
            }
            var bilhetagem = {}
  
            // INFORMA O NOME DAS CHAVES QUE DEVEM SER CONVERTIDAS
            var arrConverte = [ 'pac_nec', 'j_pac_desc' ]
  
            for (var valKeyPac in apiSuccess.data) {
              if (apiSuccess.data[valKeyPac].dt_decisao === undefined) {
                apiSuccess.data[valKeyPac].dt_decisao = moment(self.$store.state.dadosApi.dataAtual, 'DD/MM/YYYY').format('DD/MM/YYYY')
              }
              if (apiSuccess.data[valKeyPac].dt_vencimento === undefined) {
                apiSuccess.data[valKeyPac].dt_vencimento = moment(self.$store.state.dadosApi.dataAtual, 'DD/MM/YYYY').add(Number(self.$store.state.licenca.n_dias_teste), 'd').format('DD/MM/YYYY')
              }

              // INICIA O VALOR DA VARIAVEL
              if ([ '', null, undefined ].indexOf(apiSuccess.data[valKeyPac].lu_incluso) !== -1) {
                apiSuccess.data[valKeyPac].lu_incluso = '0'
              }
              // INICIA O VALOR DA VARIAVEL
              if ([ '', null, undefined ].indexOf(apiSuccess.data[valKeyPac].bilhetagem_valor) !== -1) {
                apiSuccess.data[valKeyPac].bilhetagem_valor = '0'
              }

              // CONVERTE O CAMPO QUE É DO FORMATO JSON E ESTA COMO TEXTO
              for (var valKeyCon in arrConverte) {
                apiSuccess.data[valKeyPac][arrConverte[valKeyCon]] = JSON.parse(apiSuccess.data[valKeyPac][arrConverte[valKeyCon]])
  
                if (arrConverte[valKeyCon] === 'pac_nec') {
                  for (var keyPacx in apiSuccess.data[valKeyPac][arrConverte[valKeyCon]]) {
                    apiSuccess.data[valKeyPac][arrConverte[valKeyCon]][keyPacx] = apiSuccess.data[valKeyPac][arrConverte[valKeyCon]][keyPacx].toString()
                  }
                }
              }
  
              // SALVA OS PACOTES RECEBIDOS
              var arrPacDescricao = apiSuccess.data[valKeyPac]['j_pac_desc']
  
              // ZERA AS DECRIÇÕES RECEBIDAS
              apiSuccess.data[valKeyPac]['j_pac_desc'] = ''
  
              // SETA OS DADOS DO TOOLTIP
              for (var keyDesc in arrPacDescricao) {
                apiSuccess.data[valKeyPac]['j_pac_desc'] += arrPacDescricao[keyDesc] + '<br/><br/>'
              }
  
              // SETA AS CLASSES DA LISTA
              apiSuccess.data[valKeyPac]['arrClass'] = ['list-group-item']
              if ([ 'pag_setup', 'pag_setup_2', 'pag_setup_intencao' ].indexOf(self.$route.name) !== -1 && apiSuccess.data[valKeyPac].contratado === undefined) {
                apiSuccess.data[valKeyPac].contratado = 't'
                if (pacotes.length >= 1 && pacotes.indexOf(Number(apiSuccess.data[valKeyPac].pac_id)) !== -1) {
                  self.arrPacotesSelected.push(apiSuccess.data[valKeyPac])
                } else {
                  self.arrPacotes.push(apiSuccess.data[valKeyPac])
                }
              } else {
                // ADICIONA OS VALORES EM CADA VETOR, SENDO SE O PACOTE ESTA SELECIONADO PARA LICENÇA OU NÃO
                if ([ 't', 's' ].indexOf(apiSuccess.data[valKeyPac].contratado) !== -1) {
                  self.arrPacotesSelected.push(apiSuccess.data[valKeyPac])
                } else {
                  apiSuccess.data[valKeyPac].contratado = 't'
                  self.arrPacotes.push(apiSuccess.data[valKeyPac])
                }
              }

              // SETA OS PACOTES COM BILHETAGEM
              if ((apiSuccess.data[valKeyPac].contratado === 't' || (self.cpntClu === null && [ 'd', 'dv' ].indexOf(self.contratoCLU) !== -1)) && [ '', null, undefined, '0' ].indexOf(apiSuccess.data[valKeyPac].bilhetagem_valor) === -1) {
                bilhetagem['_' + apiSuccess.data[valKeyPac].pac_id] = apiSuccess.data[valKeyPac]
              }
            }

            // SETA O VALOR MONTADO
            self.bilhetagem = bilhetagem
            
            // CHAMA A FUNÇÃO PARA TRATAR OS VALORER SELECIONADOS
            self.appConfigPacTratarValores()
  
            self.onUpdateDraggable()
          })
        }, function (apiError) {
          self.status = apiError
        })
      },
      onChangePacote: function (valNomeVet, indexPac) {
        var self = this
        self.flag = false

        var objVerificar = {}
        var arrChange = {}
        self.valInicioAcao = ''

        for (var nLinha in self.arrPacotes) {
          self.arrPacotes[nLinha]['arrClass'] = ['list-group-item']
        }

        for (var nLinhaSelected in self.arrPacotesSelected) {
          self.arrPacotesSelected[nLinhaSelected]['arrClass'] = ['list-group-item']
        }

        if (valNomeVet === 'arrPacotes') {
          arrChange = self.arrPacotes[indexPac]
          self.valInicioAcao = arrChange.pac_id

          if (self.arrPacotes[indexPac].salvo === undefined) {
            self.arrPacotes[indexPac].salvo = false
          }
          if (this.$store.state.token.dep_plus === true) {
            self.arrPacotes[indexPac].contratado = 's'
          }

          self.arrPacotesSelected.push(self.arrPacotes[indexPac])
          self.arrPacotes.splice(indexPac, 1)

          self.funVerificarPacFaltantes([ arrChange.pac_id ], {})
        } else if (valNomeVet === 'arrPacotesSelected') {
          arrChange = self.arrPacotesSelected[indexPac]
          self.valInicioAcao = arrChange.pac_id

          self.arrPacotes.push(self.arrPacotesSelected[indexPac])
          self.arrPacotesSelected.splice(indexPac, 1)

          objVerificar[arrChange.pac_id] = ''
          self.getPegaDependentes(arrChange.pac_id, objVerificar, {})
        }

        // CHAMA A FUNÇÃO PARA TRATAR OS VALORER SELECIONADOS
        this.appConfigPacTratarValores()

        // CHAMA A FUNÇÃO PARA ATUALIZAR OS VALORES DA TABELA
        this.appConfigPacAtualizarValores()
      },
      onChangeDropPacote: function ($event, valNomeVet) {
        var self = this
        valNomeVet = valNomeVet === 'arrPacotesSelected' ? 'arrPacotesSelected' : 'arrPacotes'

        setTimeout(function () {
          self.onChangePacote(valNomeVet, $event.newIndex)
        }, 700)
      },
      onUpdateDraggable: function () {
        // var self = this
        // $('.rf-info-pac').qtip('destroy', true)

        // $('.rf-info-pac').qtip({
        //   position: {
        //     my: 'top left',
        //     at: 'bottom right'
        //   },
        //   style: {
        //     classes: 'rf-qtip'
        //   }
        // })

        this.arrMensagem = {}

        this.arrPacDivergente = []

        this.valTax = 0
        this.valLic = 0
        // this.valUsu = 0
        
        // if (Object.keys(this.$store.state.licenca).length === 0) {
        //   this.valUsu += 1000
        // } else {
        //   this.valUsu += Number(this.$store.state.licenca.valor_ua.replace(',', ''))
        // }
        for (var key in this.arrPacotesSelected) {
          var pacId = this.arrPacotesSelected[key].pac_id
          this.valTax += Number(this.arrPacotesSelected[key].ti_valor)
          // SOMA OS VALORES DA LICENÇA DE USO PARA OS PACOTES QUE NÃO ESTÃO NO VETOR, POIS O PACOTE 30 É PAGO POR UTILIZAÇÃO
          if ([ '30' ].indexOf(this.arrPacotesSelected[key].pac_id) === -1) {
            this.valLic += Number(this.arrPacotesSelected[key].lu_valor)
          }

          if (this.arrPacotesSelected[key].ti_desc !== '' && this.arrPacotesSelected[key].ti_desc !== null) {
            this.arrMensagem[pacId] = '<b>Taxa Inscrição ' + this.arrPacotesSelected[key].pac_nome + '</b>: ' + this.arrPacotesSelected[key].ti_desc
          }

          if (this.arrPacotesSelected[key].lu_desc !== '' && this.arrPacotesSelected[key].lu_desc !== null) {
            this.arrMensagem[pacId] = '<b>Pacote ' + this.arrPacotesSelected[key].pac_nome + '</b>: ' + this.arrPacotesSelected[key].lu_desc
          }
        }

        if (this.valTax === '' || this.valTax === 0 || this.valTax === '0') {
          this.valTax = '0,00'
        } else {
          this.valTax = ((this.valTax) / 100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
          this.valTax = this.valTax.replace('.', ',')
        }
        this.valTax = this.valTax

        if (this.valLic === '' || this.valLic === 0 || this.valLic === '0') {
          this.valLic = '0,00'
        } else {
          this.valLic = ((this.valLic) / 100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
          this.valLic = this.valLic.replace('.', ',')
        }
        this.valLic = this.valLic

        // if (this.valUsu === '' || this.valUsu === 0 || this.valUsu === '0') {
        //   this.valUsu = '0,00'
        // } else {
        //   this.valUsu = ((this.valUsu) / 100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
        //   this.valUsu = this.valUsu.replace('.', ',')
        // }
        // this.valUsu = this.valUsu

        // CHAMA A FUNÇÃO PARA ORDENAR VETOR
        this.funOrdernarVetores()
      },
      funVerificarPacFaltantes: function (arrPacNecessario, pacVerificado) {
        if (arrPacNecessario.length > 0) {
          for (var key in arrPacNecessario) {
            var pacNecessario = this.arrPacotesSelected.filter(item => item.pac_id === arrPacNecessario[key])[0]

            if (pacNecessario.pac_nec.length > 0) {
              for (var key2 in pacNecessario.pac_nec) {
                if (!pacVerificado.hasOwnProperty(pacNecessario.pac_nec[key2])) {
                  var pacAtivado = this.arrPacotesSelected.filter(item => item.pac_id === pacNecessario.pac_nec[key2])

                  if (pacAtivado.length > 0) {
                    arrPacNecessario.push(pacNecessario.pac_nec[key2].toString())
                  } else {
                    this.arrPacDivergente.push(pacNecessario.pac_nec[key2].toString())
                  }
                }
              }
            }

            pacVerificado[pacNecessario['pac_id']] = ''
            arrPacNecessario.splice(key, 1)
          }

          this.funVerificarPacFaltantes(arrPacNecessario, pacVerificado)
        } else {
          this.funFinalizarMarcacao('adicionar')
        }
      },
      funFinalizarMarcacao: function (valTipo) {
        var self = this

        if (self.arrPacDivergente.length > 0) {
          for (var key in self.arrPacDivergente) {
            if (valTipo === 'adicionar') {
              for (var nPac in self.arrPacotes) {
                if (self.arrPacotes[nPac].pac_id === self.arrPacDivergente[key]) {
                  self.$store.state.msgWarn('WEB [406]: É necessário ativar o pacote (' + self.arrPacotes[nPac].pac_nome + ') para finalizar a alteração de pacotes.', 'danger')

                  self.arrPacotes[nPac]['arrClass'].push('alert-warning')
                  break
                }
              }
            } else if (valTipo === 'remover') {
              for (var nPacSelected in self.arrPacotesSelected) {
                if (self.arrPacotesSelected[nPacSelected].pac_id === self.arrPacDivergente[key]) {
                  self.$store.state.msgWarn('WEB [409]: É necessário desativar o pacote (' + self.arrPacotesSelected[nPacSelected].pac_nome + ') para poder desativar o pacote solicitado.', 'danger')

                  self.arrPacotesSelected[nPacSelected]['arrClass'].push('alert-warning')
                }
              }
            }
          }

          var pacSelected = {}

          if (valTipo === 'adicionar') {
            pacSelected = self.arrPacotesSelected.filter(item => item.pac_id === self.valInicioAcao)[0]
            pacSelected['arrClass'].push('alert-warning')
            self.arrPacotes.push(pacSelected)

            self.arrPacotesSelected = self.arrPacotesSelected.filter(item => item.pac_id !== self.valInicioAcao)
          } else if (valTipo === 'remover') {
            pacSelected = self.arrPacotes.filter(item => item.pac_id === self.valInicioAcao)[0]
            pacSelected['arrClass'].push('alert-warning')
            self.arrPacotesSelected.push(pacSelected)

            self.arrPacotes = self.arrPacotes.filter(item => item.pac_id !== self.valInicioAcao)
          }
        }

        // CHAMA A FUNÇÃO PARA TRATAR OS VALORER SELECIONADOS
        this.appConfigPacTratarValores()

        self.arrPacDivergente = []
        self.valInicioAcao = ''
        self.onUpdateDraggable()
      },
      getPegaDependentes: function (valVerifica, objVerificar, objVerificado) {
        var self = this

        for (var key in self.arrPacotesSelected) {
          if (!objVerificado.hasOwnProperty(self.arrPacotesSelected[key].pac_id)) {
            if (self.arrPacotesSelected[key].pac_nec.length > 0) {
              for (var key2 in self.arrPacotesSelected[key].pac_nec) {
                if (self.arrPacotesSelected[key].pac_nec[key2].toString() === valVerifica.toString()) {
                  if (self.arrPacotesSelected[key].pac_id !== self.valInicioAcao) {
                    objVerificar[self.arrPacotesSelected[key].pac_id] = ''
                  }
                }
              }
            }
          }
        }

        objVerificado[valVerifica] = ''
        delete objVerificar[String(valVerifica)]

        if (Object.keys(objVerificar).length > 0) {
          self.getPegaDependentes(Object.keys(objVerificar)[0], objVerificar, objVerificado)
        } else {
          var arrPacDivergente = Object.keys(objVerificado)
          for (var nunKey in arrPacDivergente) {
            arrPacDivergente[nunKey] = arrPacDivergente[nunKey]
          }

          if (arrPacDivergente.length === 1 && arrPacDivergente[0] === self.valInicioAcao) {
            self.arrPacDivergente = []
          } else {
            self.arrPacDivergente = arrPacDivergente
          }

          self.funFinalizarMarcacao('remover')
        }
      },
      onAtualizarPacotes: function () {
        // SETA O STATUS DE CARREGANDO
        this.statusBt = 'carregando'

        // VERIFICA SE TEM FUNÇÃO PARA CHAMAR
        if ([ '', null, undefined ].indexOf(this.cpntFecharAtualizar) === -1 && typeof this.cpntFecharAtualizar === 'function') {
          this.cpntFecharAtualizar(this.onAtualizarPacotesConfirmado)
        } else {
          this.onAtualizarPacotesConfirmado()
        }
      },
      appConfigPacSalvarAlteracaoValores: function (callback, atualizarVal = true) {
        if (this.$store.state.token.usuario !== 'SuporteRF') {
          callback()
        } else {
          // REMOVE O FOCUS DE QUALQUER CAMPO
          if (document.activeElement !== document.body) {
            document.activeElement.blur()
          }

          // INICIA O VETOR QUE SERÁ ENVIADO PARA API
          var formData = {}

          // SETA O VALOR DO DESCONTO
          formData.desconto_testando = this.valores.descontoTestando

          // SETA O VALOR DE CADA USUARIO
          formData.valor_ua = this.valores.valor_ua

          // SETA O VALOR DE CADA LICENÇA DE USO
          if (this.pac36 !== null) {
            formData.valor_cnpj_adicional = this.valores.valor_cnpj_adicional
          }

          // SETA O VALOR DE CADA LICENÇA DE USO
          if (this.pac37 !== null) {
            formData.valor_sin_clu_adicional = this.valores.valor_sin_clu_adicional
          }

          // INICIA A VARIAVEL
          formData.pacotes = {}

          // RODA O VETOR PEGANDO OS VALORES PARA ATUALIZAR
          for (var pacId in this.inputs) {
            if (pacId.indexOf('_ti') === -1 && pacId.indexOf('_lu_inc') === -1 && pacId.indexOf('_bilhetagem') === -1) {
              // VERIFICA SE O VALOR FOI INICIADO
              if ([ '', null, undefined ].indexOf(formData.pacotes[pacId]) !== -1) {
                formData.pacotes[pacId] = { id_pac: pacId }
              }
              
              // SETA O VALOR DO PACOTE
              if (this.inputsLimpar.indexOf(pacId) !== -1) {
                formData.pacotes[pacId].lu_valor_diferenciado = null
              } else if (this.inputs[pacId] !== '') {
                formData.pacotes[pacId].lu_valor_diferenciado = this.inputs[pacId]
              }
              
              // // VERIFICA SE TEM VALOR DE TAXA DE INSCRIÇÃO PARA SETAR
              // if ([ '', null, undefined ].indexOf(this.inputs[pacId + '_ti']) === -1) {
              // }
              if (this.inputsLimpar.indexOf(pacId + '_ti') !== -1) {
                formData.pacotes[pacId].ti_valor_diferenciado = null
              } else if (this.inputs[pacId + '_ti'] !== '') {
                formData.pacotes[pacId].ti_valor_diferenciado = this.inputs[pacId + '_ti']
              }

              // SETA O VALOR DO PACOTE
              if (this.inputsLimpar.indexOf(pacId + '_lu_inc') !== -1) {
                formData.pacotes[pacId].lu_incluso = null
              } else if (this.inputs[pacId + '_lu_inc'] !== '') {
                formData.pacotes[pacId].lu_incluso = this.inputs[pacId + '_lu_inc']
              }

              // SETA O VALOR DO PACOTE
              if (this.inputsLimpar.indexOf(pacId + '_bilhetagem') !== -1) {
                formData.pacotes[pacId].bilhetagem_valor_diferenciado = null
              } else if (this.inputs[pacId + '_bilhetagem'] !== '') {
                formData.pacotes[pacId].bilhetagem_valor_diferenciado = this.inputs[pacId + '_bilhetagem']
              }
              
              // REMOVE O VETOR SE NÃO PRECISAR INFORMAR 
              if (Object.keys(formData.pacotes[pacId]).length === 1) {
                delete formData.pacotes[pacId]
              }
            }
          }

          // PEGA APENAS OS VALORES DO VETOR
          if (Object.keys(formData.pacotes).length === 0) {
            delete formData.pacotes
          } else {
            formData.pacotes = Object.values(formData.pacotes)
          }

          // FAZ A COMUNICAÇÃO COM A API
          this.$store.state.comunicaAPI('/subase/financeiro/val-diferenciado', 'PUT', formData, (retorno) => {
            // APRESENTA O RETORNO
            this.$store.state.TRATAR_RET_LOT_API(retorno)

            // VERIFICA SE DEVE ATUALIZAR OS VALORES
            if (atualizarVal === true) {
              this.getPacotesExistentes()
            }

            // EXECUTA O CALLBACK
            callback()
          }, function (apiError) {
            this.status = apiError
          }, function (apiValid, apiStatus) {
            // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
            const FUN_TRATAR_VALIDACAO_API = require('@/assets/js/Funcoes-Gerais.js').FUN_TRATAR_VALIDACAO_API

            // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
            FUN_TRATAR_VALIDACAO_API(apiValid, apiStatus, {}, this).then(() => {
              // SETA O STATUS DE CARREGANDO
              this.statusBt = ''

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
            })
          })
        }
      },
      onAtualizarPacotesConfirmado: function (callback = null) {
        var self = this

        // SETA O STATUS DE CARREGANDO
        self.statusBt = 'carregando'

        if (this.$store.state.token.usuario !== 'SuporteRF' || this.hashPac !== JSON.stringify(Object.keys(this.inputs))) {
          var formData = {}
          if (this.$store.state.token.dep_plus === false && (self.contratoCLU === 'l' || self.contratoCLU === 'lv')) {
            formData.senha = self.inputSenha.value
          }
  
          formData.j_pacotes = []
  
          for (var key in self.arrPacotesSelected) {
            formData.j_pacotes.push(self.arrPacotesSelected[key].pac_id)
          }
  
          // CONVERTE O VALOR DOS PACOTES EM UM JSON
          formData.j_pacotes = JSON.stringify(formData.j_pacotes)
  
          self.$store.state.comunicaAPI('/config/pacote', 'PUT', formData, function () {
            self.$store.commit('SET_TELA_APRESENTA', [{ chave: 'menu', value: false }, { chave: 'mascara', value: true }, { chave: 'conteudo', value: false }])
  
            setTimeout(function () {
              self.$store.state.GET_VALUE_LOCAL_STORAGE(self.$store.state.token.cts, function (letra) {
                // REMOVE A TAG PARA ATUALIZAR O MENU NOVAMENTE
                delete letra.aMenu
                letra.avisos = false
  
                self.$store.state.SET_VALUE_LOCAL_STORAGE(self.$store.state.token.cts, letra, function () {
                  SESSAO_ATUALIZAR_TOKEN('clu_pcc', function () {
                    setTimeout(function () {
                      self.appConfigPacSalvarAlteracaoValores(() => {
                        self.$store.commit('SET_TELA_APRESENTA', [{ chave: 'menu', value: true }, { chave: 'mascara', value: false }, { chave: 'conteudo', value: true }])
    
                        self.$store.state.msgWarn('API [200]: Pacotes alterados com sucesso.', 'success')
    
                        // SETA A PAGINA ESTIVER ABERTA FECHA
                        if (self.cpntFecharFormulario !== null) {
                          self.cpntFecharFormulario(true)
                        } else if ([ '', null, undefined ].indexOf(callback) === -1 && typeof callback === 'function') {
                          callback()
                        }
    
                        self.getPacotesExistentes()
                      }, false)
                    }, 2000)
                  })
                }, process.env.VUE_APP_CRI_KEY)
              }, process.env.VUE_APP_CRI_KEY)
            }, 700)
          }, function (apiError) {
            self.status = apiError
          }, function (apiValid, apiStatus) {
            var apiValidResult = () => {
              if (self.cpntFecharFormulario !== null && apiValid !== undefined && apiValid.geralWeb === 'Não houve alteração dos pacotes contratados. A solicitação não foi processada.') {
                self.cpntFecharFormulario(false)
              } else {
                switch (apiStatus) {
                  case 409:
                    self.$store.state.msgWarn('API [' + apiStatus + ']: ' + apiValid.geralWeb, 'danger')
                    break
      
                  case 406:
                    self.$store.state.msgWarn('API [' + apiStatus + ']: ' + apiValid.geralWeb, 'warning')
                    break
      
                  default:
                    // eslint-disable-next-line
                    console.log(apiValid, apiStatus)
                    break
                }
      
                self.statusBt = ''
              }
            }
  
            // EXECUTA A FUNÇÃO RECEBIDA
            self.appConfigPacSalvarAlteracaoValores(apiValidResult)
            // if (apiValid !== undefined && apiValid.geralWeb === 'Não houve alteração dos pacotes contratados. A solicitação não foi processada.') {
            // }
          })
        } else {
          this.appConfigPacSalvarAlteracaoValores(() => { self.statusBt = '' })
        }
      },
      funOrdernarVetores: function () {
        var self = this

        // ORDENA O VETOR COM OS PACOTES DISPONIVEIS
        self.arrPacotes = self.arrPacotes.sort(function (a, b) {
          return a.pac_nome < b.pac_nome ? -1 : a.pac_nome > b.pac_nome ? 1 : 0
        })

        // ORDENA O VETOR COM OS PACOTES SELECIONADOS
        self.arrPacotesSelected = self.arrPacotesSelected.sort(function (a, b) {
          return a.pac_nome < b.pac_nome ? -1 : a.pac_nome > b.pac_nome ? 1 : 0
        })

        // CRIA OS QTIPS DOS BUTTONS DESATIVADOS
        for (var key1 in self.arrPacotes) {
          self.arrPacotes[key1].explica = null
          self.arrPacotes[key1].disabled = false

          // LINHA ABAIXO REMOVIDA CONFORME SOLICITADO PELO RAPHAEL PARA LIBERAR NO DIA 21/09/2022
          // if (self.$store.state.token.usuario === 'SuporteRF' && [ 'l', 'lv' ].indexOf(self.contratoCLU) !== -1) {
          //   self.arrPacotes[key1].disabled = true
          //   self.arrPacotes[key1].explica = { titulo: '', mensagem: 'Esta ação não pode ser feita com o SuporteRF.' }
          // }

          if (self.arrPacotes[key1].disabled !== null) {
            if ((self.arrPacotes[key1].pac_nec.length >= 1 && self.arrPacotes[key1].pac_nec.filter(idPacNec => self.arrPacotes.filter(item => item.pac_id === idPacNec).length >= 1).length >= 1)) {
              self.arrPacotes[key1].disabled = true

              var pacotesNec = self.arrPacotes.filter(item => self.arrPacotes[key1].pac_nec.indexOf(item.pac_id) !== -1)

              if (pacotesNec.length >= 1) {
                if (self.arrPacotes[key1].explica === null) {
                  self.arrPacotes[key1].explica = { mensagem: '' }
                }

                // SETA O INICIO DA MENSAGEM
                self.arrPacotes[key1].explica.mensagem += 'Para ativar este pacote é necessário ativar o' + (pacotesNec.length >= 2 ? 's' : '') + ' pacote ' + (pacotesNec.length >= 2 ? 's' : '') + ' abaixo:<br/><ul>'

                // ADICIONA O NOME DOS PACOTES
                for (var key2 in pacotesNec) {
                  self.arrPacotes[key1].explica.mensagem += '<li>' + pacotesNec[key2].pac_nome + '</li>'
                }

                // FINALIZA A LISTA DE PACOTES
                self.arrPacotes[key1].explica.mensagem += '</ul>'
              }
            }

            if (self.arrPacotes[key1].explica !== null) {
              self.arrPacotes[key1].explica.titulo = 'Rotina Fácil - Pacotes necessários'
            }
          }

          // MONTA AS INFORMAÇÕES DO PACOTE
          self.arrPacotes[key1].info = { mensagem: self.montarInfoPacote(self.arrPacotes[key1]) }
        }

        // CRIA OS QTIPS DOS BUTTONS DESATIVADOS
        for (var key3 in self.arrPacotesSelected) {
          self.arrPacotesSelected[key3].explica = null
          self.arrPacotesSelected[key3].disabled = false

          if (self.cpntClu !== null) {
            self.arrPacotesSelected[key3].disabled = false
          } else if (self.$store.state.token.dep_plus === true || self.$store.state.token.usuario === 'SuporteRF') {
            self.arrPacotesSelected[key3].disabled = false
          } else if ([ 'l', 'lv' ].indexOf(self.contratoCLU) === -1) {
            self.arrPacotesSelected[key3].disabled = false
          } else {
            self.arrPacotesSelected[key3].disabled = null
          }

          if (self.arrPacotesSelected[key3].disabled !== null) {
            if (self.arrPacotesSelected.filter(item => item.pac_nec.indexOf(self.arrPacotesSelected[key3].pac_id) !== -1).length >= 1) {
              self.arrPacotesSelected[key3].disabled = true

              self.arrPacotesSelected[key3].pacoteDep = self.arrPacotesSelected.filter(item => item.pac_nec.indexOf(self.arrPacotesSelected[key3].pac_id) !== -1)
              self.arrPacotesSelected[key3].pacoteDep = self.arrPacotesSelected[key3].pacoteDep.filter(item => item.pac_id !== '1')

              if (self.arrPacotesSelected[key3].pacoteDep.length >= 1) {
                if (self.arrPacotesSelected[key3].explica === null) {
                  self.arrPacotesSelected[key3].explica = { mensagem: '' }
                }

                // SETA O INICIO DA MENSAGEM
                self.arrPacotesSelected[key3].explica.mensagem += 'Para desativar este pacote é necessário desativar o' + (self.arrPacotesSelected[key3].pacoteDep.length >= 2 ? 's' : '') + ' pacote ' + (self.arrPacotesSelected[key3].pacoteDep.length >= 2 ? 's' : '') + ' abaixo:<br/><ul>'

                // ADICIONA O NOME DOS PACOTES
                for (var key4 in self.arrPacotesSelected[key3].pacoteDep) {
                  self.arrPacotesSelected[key3].explica.mensagem += '<li>' + self.arrPacotesSelected[key3].pacoteDep[key4].pac_nome + '</li>'
                }

                // FINALIZA A LISTA DE PACOTES
                self.arrPacotesSelected[key3].explica.mensagem += '</ul>'
              }
            }

            if (self.arrPacotesSelected[key3].explica !== null) {
              self.arrPacotesSelected[key3].explica.titulo = 'Rotina Fácil - Pacotes Dependentes'
            }
          }

          // MONTA AS INFORMAÇÕES DO PACOTE
          self.arrPacotesSelected[key3].info = { mensagem: self.montarInfoPacote(self.arrPacotesSelected[key3]) }
        }        

        // CHAMA A FUNÇÃO PARA TRATAR OS VALORER SELECIONADOS
        this.appConfigPacTratarValores()

        // CHAMA A FUNÇÃO PRA VER SE DEVE ATIVAR O BOTÃO
        this.onVerificaButton()

        setTimeout(function () {
          // SETA O FLAG
          self.flag = true

          // SETA O STATUS DE CARREGANDO
          self.status = ''

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()
        }, 100)
      },
      montarInfoPacote: function (pacote) {
        // MONTA A EXPLICAÇÃO DO PACOTE
        var tabela = ''

        tabela += '<table style="text-align: left;">'
          tabela += '<tr>'
            tabela += '<td colspan="3">'
              tabela += '<b>Pacote: </b>'
              tabela += pacote.pac_id + ' - ' + pacote.pac_nome
            tabela += '</td>'
          tabela += '</tr>'

          if (this.$store.state.token.usuario === 'SuporteRF' || pacote.contratado === 'n') {
            tabela += '<tr>'
              tabela += '<td>'
                tabela += '<b>Taxa Inscrição: </b> R$ '
                tabela += this.$store.state.FUN_MASK_VALOR('valorMoeda', pacote.ti_valor)
              tabela += '</td>'
              tabela += '<td>'
                tabela += '<b>Valor: </b> R$ '
                tabela += this.$store.state.FUN_MASK_VALOR('valorMoeda', pacote.lu_valor)
                if (pacote.pac_id === '30') {
                  tabela += '/GB'
                } else if (pacote.pac_id === '37') {
                  tabela += '/CLU Adicional'
                }
                tabela += '/mês'
              tabela += '</td>'
            tabela += '</tr>'
          }

          switch (pacote.contratado) {
            case 't':
              tabela += '<tr>'
                tabela += '<td>'
                  tabela += '<b>Status: </b>'
                  tabela += 'Testando'
                tabela += '</td>'
                tabela += '<td>'
                  tabela += '<b>Início do teste: </b>'
                  tabela += pacote.dt_decisao
                tabela += '</td>'
                tabela += '<td>'
                  tabela += '<b>Fim do teste: </b>'
                  tabela += pacote.dt_vencimento
                tabela += '</td>'
              tabela += '</tr>'
              break

            case 's':
              tabela += '<tr>'
                tabela += '<td>'
                  tabela += '<b>Status: </b>'
                  tabela += 'Contratado'
                tabela += '</td>'
                tabela += '<td>'
                  tabela += '<b>Contratado em: </b>'
                  tabela += pacote.dt_decisao
                tabela += '</td>'
              tabela += '</tr>'
              break
          }

          var dependetes = []
          for (var dp in pacote.pacoteDep) {
            dependetes.push(pacote.pacoteDep[dp].pac_nome)
          }
          if (dependetes.length >= 1) {
            tabela += '<tr>'
              tabela += '<td colspan="3">'
                tabela += '<b>Pacotes Dependentes: </b>'
              tabela += dependetes.join(', ')
              tabela += '</td>'
            tabela += '</tr>'
          }

          tabela += '<tr>'
            tabela += '<td colspan="3">'
              tabela += '<b>Descrição: </b><ul style="padding-left: 20px;">'
              var desc = pacote.j_pac_desc.split('<br/><br/>')
              for (var i in desc) {
                if ([ '', null, undefined ].indexOf(desc[i]) === -1) {
                  tabela += '<li style="margin: 4px; 0px;">' + desc[i] + '</li>'
                }
              }
            tabela += '</ul></td>'
          tabela += '</tr>'
        tabela += '</table>'

        return tabela
      },

      onChangePassword: function (value) {
        // SETA O NOVO VALOR DO INPUT
        this.inputSenha.value = value

        // CHAMA A FUNÇÃO PRA VER SE DEVE ATIVAR O BOTÃO
        this.onVerificaButton()
      },
      appConfigPacTratarValores: function () {
        // INICIA A VARIAVEL DE PACOTES
        var pacote = ''

        // VERIFICA SE O PACOTE 30 ESTÁ SELECIONADO
        pacote = this.arrPacotesSelected.filter(item => item.pac_id === '25')
        
        // VERIFICA SE TEM VALOR A SER TRATADO
        if (pacote.length >= 1) {
          // PEGA O VALOR DO PACOTE
          this.pac25 = pacote[0]

          // DEIXA APENAS A PRIMEIRA LETRA MAIUSCULA
          this.pac25._pac_nome = this.pac25.pac_nome[0].toUpperCase() + this.pac25.pac_nome.toLowerCase().substr(1)

          // TRATA O VALOR RECEBIDO
          this.pac25._lu_valor = this.$store.state.FUN_MASK_VALOR('valorMoeda', this.pac25.lu_valor)
        } else {
          this.pac25 = null
        }

        // VERIFICA SE O PACOTE 30 ESTÁ SELECIONADO
        pacote = this.arrPacotesSelected.filter(item => item.pac_id === '30')
        
        // VERIFICA SE TEM VALOR A SER TRATADO
        if (pacote.length >= 1) {
          // PEGA O VALOR DO PACOTE
          this.pac30 = pacote[0]

          // DEIXA APENAS A PRIMEIRA LETRA MAIUSCULA
          this.pac30._pac_nome = this.pac30.pac_nome[0].toUpperCase() + this.pac30.pac_nome.toLowerCase().substr(1)

          // TRATA O VALOR RECEBIDO
          this.pac30._lu_valor = this.$store.state.FUN_MASK_VALOR('valorMoeda', this.pac30.lu_valor)
        } else {
          this.pac30 = null
        }
        
        // VERIFICA SE O PACOTE 30 ESTÁ SELECIONADO
        pacote = this.arrPacotesSelected.filter(item => item.pac_id === '37')

        // VERIFICA SE TEM VALOR A SER TRATADO
        if (pacote.length >= 1) {
          // PEGA O VALOR DO PACOTE
          this.pac37 = pacote[0]

          // DEIXA APENAS A PRIMEIRA LETRA MAIUSCULA
          this.pac37._pac_nome = this.pac37.pac_nome[0].toUpperCase() + this.pac37.pac_nome.toLowerCase().substr(1)

          // TRATA O VALOR RECEBIDO
          this.pac37._lu_valor = this.$store.state.FUN_MASK_VALOR('valorMoeda', this.pac37.lu_valor)
        } else {
          this.pac37 = null
        }
        
        // VERIFICA SE O PACOTE 30 ESTÁ SELECIONADO
        pacote = this.arrPacotesSelected.filter(item => item.pac_id === '36')

        // VERIFICA SE TEM VALOR A SER TRATADO
        if (pacote.length >= 1) {
          // PEGA O VALOR DO PACOTE
          this.pac36 = pacote[0]

          // DEIXA APENAS A PRIMEIRA LETRA MAIUSCULA
          this.pac36._pac_nome = this.pac36.pac_nome[0].toUpperCase() + this.pac36.pac_nome.toLowerCase().substr(1)

          // TRATA O VALOR RECEBIDO
          this.pac36._lu_valor = this.$store.state.FUN_MASK_VALOR('valorMoeda', this.pac36.lu_valor)
        } else {
          this.pac36 = null
        }

        // VERIFICA AS INFORMAÇÕES INICIAIS DO PACOTE
        for (var index in this.arrPacotesSelected) {
          // SETA O ID DO PACOTE
          var pacId = this.arrPacotesSelected[index].pac_id

          // VERIFICA SE JÁ EXISTE O VALOR
          if (this.inputs[pacId] === undefined) {
            this.inputs[pacId] = ''
          }
          if (this.inputs[pacId + '_ti'] === undefined) {
            this.inputs[pacId + '_ti'] = ''
          }
          if (this.inputs[pacId + '_lu_inc'] === undefined) {
            this.inputs[pacId + '_lu_inc'] = ''
          }
          if (this.inputs[pacId + '_bilhetagem'] === undefined) {
            this.inputs[pacId + '_bilhetagem'] = ''
          }

          // // INICIA O VALOR DA VARIAVEL
          // if ([ '', null, undefined ].indexOf(this.arrPacotesSelected[index].lu_incluso) !== -1) {
          //   this.arrPacotesSelected[index].lu_incluso = '0'
          // }
          // // INICIA O VALOR DA VARIAVEL
          // if ([ '', null, undefined ].indexOf(this.arrPacotesSelected[index].bilhetagem_valor) !== -1) {
          //   this.arrPacotesSelected[index].bilhetagem_valor = '0'
          // }
        }

        // VERIFICA SE TEM HASH A SER MOSTRADO
        if (this.hashPac === null && Object.keys(this.inputs).length >= 1) {
          this.hashPac = JSON.stringify(Object.keys(this.inputs))
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      appConfigPacAtualizarValores: function () {
        // INICIA A VARIAVEL VALOR
        var valorPac = 0
        var valorTax = 0
        var valorPacTes = 0
        var valorTiTes = 0
        var valor = 0
        var flag = false
        var pacVerificado = [ '1', '1_ti', '1_lu_inc', '1_bilhetagem' ]

        // VERIFICA AS INFORMAÇÕES INICIAIS DO PACOTE
        for (var index in this.arrPacotesSelected) {
          // SETA O ID DO PACOTE
          var pacId = this.arrPacotesSelected[index].pac_id

          // SETA O VALOR DA LICENÇA DE USO
          if ([ 30, '30', 37, '37' ].indexOf(this.arrPacotesSelected[index].pac_id) === -1) {
            // PEGA O VALOR DO PACOTE
            valor = Number(this.arrPacotesSelected[index].lu_valor)

            // PEGA O VALOR NOVO DO PACOTE
            if (this.inputs[pacId] !== '' && this.inputs[pacId] !== undefined) {
              valor = Number(this.inputs[pacId])
            }

            // SOMA O VALOR ENCONTRADO
            if ([ 'l', 'lv' ].indexOf(this.contratoCLU) === -1 || ([ 'l', 'lv' ].indexOf(this.contratoCLU) !== -1 && this.arrPacotesSelected[index].contratado === 's')) {
              valorPac += valor
            } else {
              flag = true
              valorPacTes += valor
            }
          }

          // PEGA O VALOR DA TAXA
          valor = Number(this.arrPacotesSelected[index].ti_valor)

          // PEGA O VALOR NOVO DA TAXA
          if (this.inputs[pacId + '_ti'] !== '' && this.inputs[pacId + '_ti'] !== undefined) {
            valor = Number(this.inputs[pacId + '_ti'])
          }

          // SOMA O VALOR ENCONTRADO
          if ([ 'l', 'lv' ].indexOf(this.contratoCLU) === -1 || ([ 'l', 'lv' ].indexOf(this.contratoCLU) !== -1 && this.arrPacotesSelected[index].contratado === 's')) {
            valorTax += valor
          } else {
            flag = true
            valorTiTes += valor
          }

          // ADICIONA O VALOR NO VETOR
          pacVerificado.push(pacId)
          pacVerificado.push(pacId + '_ti')
          pacVerificado.push(pacId + '_lu_inc')
          pacVerificado.push(pacId + '_bilhetagem')
        }

        // PEGA APENAS OS PACOTES QUE TEM QUE EXCLUIR
        var excluir = Object.keys(this.inputs).filter(item => (pacVerificado.indexOf(item) === -1 && pacVerificado.indexOf(item + '_ti') === -1))

        // VERIFICA SE TEM COISA PARA EXCLUIR
        if (excluir.length >= 1) {
          flag = true 
        }

        // REMOVE AS CHAVES DO VETOR
        for (var indexD in excluir) {
          delete this.inputs[excluir[indexD]]
        }
        // console.log(valorTax, valorPac, valorPacTes, valorTiTes)

        // SETA OS NOVOS VALORES DA TAXA
        // this.valores.virtual_valor_ti.valor = valorTax
        this.valores.virtual_valor_ti = valorTax.toString()
        // this.valores.virtual_valor_ti.formatado = this.$store.state.FUN_MASK_VALOR('valorMoeda', this.valores.virtual_valor_ti.valor.toString())
        
        // SETA OS NOVOS VALORES DOS PACOTES
        this.valores.virtual_valor_pacote = valorPac.toString()
        
        // VERIFICA SE TEM O CONTRATO
        if (flag === true) {
          // SETA OS NOVOS VALORES DOS PACOTES
          this.valores.pacoteValorTestando = valorPacTes === 0 ? '' : valorPacTes.toString()

          // SETA OS NOVOS VALORES DOS PACOTES
          this.valores.pacoteTiValorTestando = valorTiTes.toString()
        }
        // this.valores.virtual_valor_pacote.formatado = this.$store.state.FUN_MASK_VALOR('valorMoeda', this.valores.virtual_valor_pacote.valor.toString())
        
        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      onVerificaButton: function () {
        // VERIFICA SE DEVE ATIVAR OU DESATIVAR O BOTÃO
        if (this.$store.state.token.dep_plus === false && (this.contratoCLU === 'l' || this.contratoCLU === 'lv')) {
          if (this.inputSenha.value.length === 0) {
            this.disabledBt = true
            this.explicaBt = { mensagem: 'Para continuar preencha a senha de acesso do seu usuário no campo acima.' }
          } else {
            this.disabledBt = false
            this.explicaBt = null
          }
        } else {
          this.disabledBt = false
          this.explicaBt = null
        }
      },
      appConfigPacOnChangeValor: function (value, pacId) {
        // SETA O VALOR DO CAMPO
        this.inputs[pacId] = value

        // VERIFICA SE É UMA ATUALIZAÇÃO DE BILHETAGEM
        if (pacId.indexOf('_bilhetagem') !== -1) {
          // PEGA O ID DO PACOTE
          pacId = '_' + pacId.split('_bilhetagem')[0].toString()

          // SETA O NOVO VALOR DO CAMPO
          this.bilhetagem[pacId].bilhetagem_valor = value
        } else if (pacId.indexOf('_lu_inc') !== -1) {
          // PEGA O ID DO PACOTE
          pacId = '_' + pacId.split('_lu_inc')[0].toString()

          // SETA O NOVO VALOR DO CAMPO
          this.bilhetagem[pacId].lu_incluso = value
        }
        // this.bilhetagem[]

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
        
        // CHAMA A FUNÇÃO PARA ATUALIZAR OS VALORES
        this.appConfigPacAtualizarValores()
      },
      appConfigPacOnChangeCampoValor: function (value, campo) {
        // SETA OS NOVOS VALORES DOS PACOTES
        this.valores[campo].valor = value
        this.valores[campo].formatado = this.$store.state.FUN_MASK_VALOR('valorMoeda', this.valores[campo].valor.toString())

        // VERIFICA SE O CAMPO TEM CALCULO
        if (campo === 'valor_ua') {
          this.valores.valor_ua_total.valor = (Number(this.valores.valor_ua.valor) * Number(this.valores.virtual_n_ua)).toString()
          this.valores.valor_ua_total.formatado = this.$store.state.FUN_MASK_VALOR('valorMoeda', this.valores.valor_ua_total.valor.toString())
        } else if (campo === 'valor_cnpj_adicional') {
          this.valores.valor_cnpj_adicional_total.valor = (Number(this.valores.valor_cnpj_adicional.valor) * Number(this.valores.virtual_n_ua)).toString()
          this.valores.valor_cnpj_adicional_total.formatado = this.$store.state.FUN_MASK_VALOR('valorMoeda', this.valores.valor_cnpj_adicional_total.valor.toString())
        }
        
        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // // SETA O VALOR DO CAMPO
        // this[campo] = value

        // // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        // this.time = new Date().getTime()
      },
      appConfigPacContratarFechar: function () {
        // SETA O ID DO PACOTE QUE DEVE CONTRATAR
        this.contratar = null

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      appConfigPacContratar: function (pacote) {
        // SETA O ID DO PACOTE QUE DEVE CONTRATAR
        this.contratar = [ Number(pacote.pac_id) ]

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      }
    },
    // computed: {
    //   configPacCalcularTotalMensal: function () {
    //     // VERIFICA SE TEM LICENÇA VALOR LICENÇA DE USO
    //     var valor = Number(this.valores.virtual_valor_pacote.valor)
        
    //     // SOMA O VALOR TOTAL DOS USUARIOS
    //     valor += Number(this.valores.valor_ua_total.valor)
        
    //     // SOMA O VALOR TOTAL DOS CNPJS CONTADOR PLUS
    //     valor += Number(this.valores.valor_cnpj_adicional_total.valor)
        
    //     // SOMA O VALOR TOTAL DOS CNPJS CONTADOR PLUS
    //     valor += Number(this.valores.virtual_sincronizar_valor_total.valor)
        
    //     // SOMA O VALOR TOTAL DOS CNPJS CONTADOR PLUS
    //     valor += Number(this.valores.virtual_arm_arquivo_valor_por_gb_total.valor)
        
    //     // DESCONTA O VALOR DO DESCONTO
    //     valor -= Number(this.valores.desconto.valor)

    //     // RETORNA O VALOR CALCULADO E FORMATADO
    //     return this.$store.state.FUN_MASK_VALOR('valorMoeda', valor.toString())
    //   }
    // }
  }
</script>
